<template>
  <div class="wrapper">
    <AperturaCajaModal
      :isVisible="isAperturaCajaModalVisible"
      @confirmar="handleAperturaCaja"
    />
    <ModalLoading :isLoading="isModalLoading" />
    <PaymentAnimationModal
      :isVisible="isPaymentAnimationVisible"
      @complete="handlePaymentComplete"
    />
    <FacturaModal
      :isVisible="isFacturaModalVisible"
      :idVenta="venta?.id_venta"
      :idUsuario="id_usuario"
      @close="closeFacturaModal"
    />

    <CerrarCajaModal
      :isVisible="isCerrarCajaModalVisible"
      :totalEfectivo="totalEfectivo"
      :totalTransferencia="totalTransferencia"
      @confirm="confirmarCierreCaja"
      @close="isCerrarCajaModalVisible = false"
      @modal-focused="handleModalFocus"
    />

    <!-- NUEVOS MODALES DE DESCUENTO -->
    <DescuentoProductoModal
      :isVisible="isDescuentoProductoModalVisible"
      :producto="selectedItem"
      @close="isDescuentoProductoModalVisible = false"
      @aplicar-descuento="handleDescuentoProducto"
      @modal-focused="handleModalFocus"
    />

    <DescuentoGeneralModal
  :isVisible="isDescuentoGeneralModalVisible"
  :totalVenta="calcularTotalSinDescuentoGeneral"
  :cantidadProductos="productosLista.length"
  :productos="productosLista"
  @close="isDescuentoGeneralModalVisible = false"
  @aplicar-descuento="handleDescuentoGeneral"
  @modal-focused="handleModalFocus"
/>

    <div class="main-container">

      <!-- Botón volver — solo visible cuando Admin entra a caja -->
      <button v-if="isAdminEnCaja" class="admin-caja-back" @click="volverAlPanel">
        <i class="bi bi-arrow-left-short"></i> Volver al panel
      </button>

      <div class="header-container">
        <div class="tipo-cliente">
          <label for="tipo-cliente">Cliente:</label>
          <div class="input-button-container">
            <div class="inputs-container">
              <template v-if="!clienteSeleccionado">
                <input
                  type="text"
                  value="Consumidor final"
                  readonly
                  class="cliente-input single"
                />
              </template>
              <template v-else>
                <input
                  type="text"
                  :value="clienteSeleccionado.nombre_completo"
                  readonly
                  class="cliente-input"
                />
                <input
                  type="text"
                  :value="clienteSeleccionado.rtn"
                  readonly
                  class="rtn-input"
                />
                <span
                  v-if="clienteSeleccionado.tipo_cliente && clienteSeleccionado.tipo_cliente !== 'Normal'"
                  class="cliente-tipo-badge"
                  :class="'badge-tipo-' + (clienteSeleccionado.tipo_cliente || 'Normal').toLowerCase()"
                >{{ clienteSeleccionado.tipo_cliente }}{{ clienteSeleccionado.descuento_habitual > 0 ? ' -' + clienteSeleccionado.descuento_habitual + '%' : '' }}</span>
              </template>
            </div>
            <div class="buttons-header">
              <button
                :disabled="!cajaAbierta"
                class="search-button"
                @click="openModal"
              >
                Buscar
              </button>
              <ClienteModal
                ref="clienteModal"
                :isVisible="isModalVisible"
                :clientes="clientes"
                :id_usuario="id_usuario"
                :puedeCrearCliente="puedeCrearCliente"
                @close="closeModal"
                @client-selected="handleClientSelected"
              />
              <!-- Botón para volver a "Consumidor final" -->
              <button
                v-if="clienteSeleccionado"
                class="search-button"
                @click="setConsumidorFinal"
              >
                Consumidor final
              </button>
            </div>
          </div>
        </div>

        <div class="informacion-1">
          <label for="sucursal">Sucursal: {{ sucursalNombre }}</label>
          <br />
          <label v-if="!isCajaAbierta" class="no-facturando"
            >Abrir caja antes de facturar!</label
          >
          <label v-else for="usuario">Usuario: {{ info.nombre_usuario }}</label>
        </div>

        <div class="informacion-2">
          <label
            for="numTicket"
            :class="sucursalActivaFactura ? 'facturando' : 'no-facturando'"
          >
            {{
              sucursalActivaFactura
                ? "Sucursal facturando"
                : "Datos SAR Sucursal desactualizados"
            }}
          </label>
          <br />
          <label
            >Fecha: <span>{{ info.fecha }}</span></label
          >
        </div>

      </div><!-- /header-container -->

      <!-- PILL DE USUARIO (fixed top-right) -->
      <div class="usr-pill-wrap" ref="usrDropRef">
          <button
            class="usr-pill"
            :class="{ active: profileDropdownOpen }"
            @click="profileDropdownOpen = !profileDropdownOpen"
          >
            <div class="usr-avatar">{{ userInitials }}</div>
            <div class="usr-info">
              <span class="usr-name">{{ perfil.nombre }} {{ perfil.apellido }}</span>
              <span class="usr-role">Cajero</span>
            </div>
            <i class="bi bi-chevron-down usr-caret" :class="{ rotated: profileDropdownOpen }"></i>
          </button>

          <transition name="usr-dd-fade">
            <div v-if="profileDropdownOpen" class="usr-dropdown">
              <div class="usr-dd-header">
                <div class="usr-dd-avatar">{{ userInitials }}</div>
                <div>
                  <span class="usr-dd-name">{{ perfil.nombre }} {{ perfil.apellido }}</span>
                  <span class="usr-dd-role">Cajero</span>
                </div>
              </div>
              <div class="usr-dd-divider"></div>

              <button class="usr-dd-item" @click="profileDropdownOpen = false; showHelpModal = true">
                <div class="usr-dd-icon"><i class="bi bi-book-fill"></i></div>
                <div class="usr-dd-text">
                  <span class="usr-dd-label">Documentación</span>
                  <span class="usr-dd-sub">Guía del cajero</span>
                </div>
              </button>

              <button class="usr-dd-item" @click="openCuentaModal">
                <div class="usr-dd-icon"><i class="bi bi-person-fill"></i></div>
                <div class="usr-dd-text">
                  <span class="usr-dd-label">Mi cuenta</span>
                  <span class="usr-dd-sub">Cambiar usuario o contraseña</span>
                </div>
              </button>

              <div class="usr-dd-divider"></div>

              <button class="usr-dd-item danger" @click="profileDropdownOpen = false; salir()">
                <div class="usr-dd-icon"><i class="bi bi-box-arrow-right"></i></div>
                <div class="usr-dd-text">
                  <span class="usr-dd-label">Cerrar sesión</span>
                </div>
              </button>
            </div>
          </transition>
        </div>

      <!-- MODAL MI CUENTA -->
      <div v-if="showCuentaModal" class="cuenta-overlay">
        <div class="cuenta-modal">
          <button class="modal-close-x" @click="closeCuentaModal">✕</button>
          <div class="cuenta-header">
            <div class="cuenta-avatar-lg">{{ userInitials }}</div>
            <div>
              <h2 class="cuenta-title">Mi cuenta</h2>
              <span class="cuenta-subtitle">{{ perfil.nombre }} {{ perfil.apellido }}</span>
            </div>
          </div>

          <form @submit.prevent="saveCuenta" class="cuenta-form">
            <div class="cuenta-section-title">Información de acceso</div>

            <div class="cuenta-field">
              <label>Nombre de usuario</label>
              <input v-model="cuentaForm.nombre_usuario" type="text" placeholder="Usuario" autocomplete="username" />
            </div>

            <div class="cuenta-section-title" style="margin-top:16px">Cambiar contraseña <span class="cuenta-opt">(opcional)</span></div>

            <div class="cuenta-field">
              <label>Contraseña actual</label>
              <input v-model="cuentaForm.contrasena" type="password" placeholder="••••••••" autocomplete="current-password" />
            </div>
            <div class="cuenta-field">
              <label>Contraseña nueva</label>
              <input v-model="cuentaForm.contrasena_nueva" type="password" placeholder="••••••••" autocomplete="new-password" />
            </div>
            <div class="cuenta-field">
              <label>Confirmar nueva</label>
              <input v-model="cuentaForm.contrasena_confirm" type="password" placeholder="••••••••" autocomplete="new-password" />
            </div>

            <div class="cuenta-actions">
              <button type="button" class="btn-cuenta-cancel" @click="closeCuentaModal">Cancelar</button>
              <button type="submit" class="btn-cuenta-save" :disabled="cuentaLoading">
                {{ cuentaLoading ? 'Guardando…' : 'Guardar cambios' }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="column-container">
        <div class="table-container">
          <div class="table-wrapper">
            <table class="table">
              <thead>
                <tr>
                  <th class="col-item">Item</th>
                  <th class="col-codigo">Código</th>
                  <th class="col-descripcion">Producto</th>
                  <th class="col-cantidad">Cantidad</th>
                  <th class="col-precio">Precio</th>
                  <th class="col-precio">Subtotal</th>
                  <th class="col-descuento">Descuento</th>
                  <th class="col-tipo-desc">Tipo</th>
                  <th class="col-importe">Total</th>
                </tr>
              </thead>
              <tbody>
                <!-- Productos reales -->
                <tr
                  v-for="(producto, index) in productosLista"
                  :key="index"
                  @dblclick="handleRowDoubleClick(producto)"
                  :class="{ 
                    selected: selectedItem === producto,
                    'tercera-edad-product': clienteSeleccionado?.es_tercera_edad
                  }"
                >
                  <td class="col-item">{{ index + 1 }}</td>
                  <td class="col-codigo">{{ producto.codigo_producto }}</td>
                  <td class="col-descripcion">{{ producto.nombre }}</td>
                  <td class="col-cantidad">{{ producto.cantidad }}</td>
                  <td class="col-precio">{{ mostrarPrecioFinal(producto) }}</td>
                  <td class="col-precio">
                    {{ mostrarPrecioConImpuesto(producto) }}
                  </td>
                  <td class="col-descuento">
                    {{ calcularDescuento(producto) }}
                  </td>
                  <td class="col-tipo-desc">{{ obtenerTipoDescuento(producto) }}</td>
                  <td class="col-importe">{{ calcularImporte(producto) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="total-container">
            <div class="cantidad-input">
              <label for="cantidad">Cant:</label>
              <input
                id="cantidad"
                type="number"
                v-model="totalCantidad"
                min="1"
                step="1"
                @blur="handleCantidadBlur"
                @focus="handleCantidadFocus"
              />
            </div>
            <div class="total-input">
              <label for="total">Total:</label>
              <label class="subTotal" id="total">{{ calcularTotal }}</label>
            </div>
            <!-- Mostrar resumen de descuentos -->
            <div v-if="clienteSeleccionado?.es_tercera_edad && totalDescuentoTerceraEdad > 0" class="descuento-resumen">
              <span>💰 Ahorrado: L. {{ totalDescuentoTerceraEdad.toFixed(2) }}</span>
            </div>
            <div v-if="descuentoGeneralAplicado > 0" class="descuento-resumen">
              <span>🎯 Descuento General: L. {{ descuentoGeneralAplicado.toFixed(2) }}</span>
            </div>
          </div>
        </div>
        <div class="right-section">
          <div class="numeric-keypad">
             <!-- Overlay caja cerrada: visible en móvil para bloquear el teclado -->
             <div v-if="!cajaAbierta" class="keypad-cerrado-overlay" @click="abrirCaja">
               <div class="keypad-cerrado-msg">
                 <i class="bi bi-lock-fill"></i>
                 <p>Caja cerrada</p>
                 <span>Toca para abrir</span>
               </div>
             </div>
            <input
              name="codigo-producto"
              autocomplete="off0"
              ref="codigoRef"
              type="text"
              class="campo"
              v-model="addQuery"
              tabindex="1"
              :disabled="!cajaAbierta || isModalFocused || isModalVisible"
              required
              @keydown.enter.prevent="procesarEnter"
            />

            <div class="keypad">
              <button :disabled="!cajaAbierta" @click="agregarNumero(1)">
                1
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(2)">
                2
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(3)">
                3
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(4)">
                4
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(5)">
                5
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(6)">
                6
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(7)">
                7
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(8)">
                8
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(9)">
                9
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero(0)">
                0
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero('.')">
                .
              </button>
              <button :disabled="!cajaAbierta" @click="agregarNumero('*')">
                *
              </button>
              <button
                :disabled="!cajaAbierta"
                class="borrar"
                @click="borrarUltimo"
              >
                ←
              </button>
              <button :disabled="!cajaAbierta" class="limpiar" @click="limpiar">
                Limpiar
              </button>
              <button
                :disabled="!cajaAbierta"
                class="enter"
                @click="procesarEnter"
              >
                Enter
              </button>
            </div>
          </div>

          <button
            v-if="!cajaAbierta"
            class="abrir-caja-button"
            @click="abrirCaja"
          >
            Abrir caja
          </button>
          <button
            v-if="cajaAbierta"
            class="abrir-caja-button"
            @click="cerrarCaja"
            style="background-color: crimson"
          >
            Cerrar caja
          </button>
        </div>
      </div>

      <!-- ═══ NOTIFICACIÓN VENTA ANULADA ══════════════════════════════ -->
      <div v-if="notifAnulacion" class="notif-anulacion-banner">
        <div class="notif-anulacion-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
        <div class="notif-anulacion-text">
          <strong>Venta anulada por {{ notifAnulacion.cancelado_por || 'Administrador' }}</strong>
          <span v-if="notifAnulacion.numero_factura"> — Factura {{ notifAnulacion.numero_factura }}</span>
          <span v-if="notifAnulacion.motivo" style="font-size:12px;color:#ffe082;display:block">Motivo: {{ notifAnulacion.motivo }}</span>
        </div>
        <button class="notif-anulacion-close" @click="notifAnulacion = null" title="Cerrar">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="footer-container">
        <button :disabled="!cajaAbierta" @click="buscarProducto">
          Buscar producto [F2]
        </button>
        <BuscarProductoModal
          :isVisible="isBuscarProductoModalVisible"
          :productos="productos"
          @close="closeBuscarProductoModal"
          @product-selected="handleProductSelected"
          @modal-focused="handleModalFocus"
        />
        <button :disabled="!cajaAbierta" @click="openModal">
          Buscar/agregar cliente <br />
          [F3]
        </button>
        <button :disabled="!cajaAbierta" @click="eliminarItem">
          Eliminar item <br />
          [F4]
        </button>
        <EliminarItemsModal
          :isVisible="isEliminarModalVisible"
          :item="selectedItem"
          @close="closeEliminarModal"
          @confirm-delete="handleItemDelete"
          @modal-focused="handleModalFocus"
        />
        <button :disabled="!cajaAbierta" @click="limpiarPantalla">
          Limpiar pantalla [F5]
        </button>
        <LimpiarPantallaModal
          :isVisible="isLimpiarPantallaModalVisible"
          @close="closeLimpiarPantallaModal"
          @confirm-limpiar="handleLimpiarPantalla"
          @modal-focused="handleModalFocus"
        />
        <button :disabled="!cajaAbierta" @click="guardarVenta">
          Guardar venta <br />
          [F6]
        </button>
        <GuardarVentaModal
          :isVisible="isGuardarVentaModalVisible"
          :isConsumidorFinal="!clienteSeleccionado"
          @close="isGuardarVentaModalVisible = false"
          @cliente-temporal="handleSaveVenta"
          @modal-focused="handleModalFocus"
        />
        <button :disabled="!cajaAbierta" @click="recVenta">
          Recuperar Venta [F7]
        </button>
        <RecuperarVentaModal
          :isVisible="isRecuperarVentaModalVisible"
          :ventas="ventasGuardadas"
          @close="isRecuperarVentaModalVisible = false"
          @venta-selected="handleVentaSelected"
        />
        <!-- NUEVOS BOTONES DE DESCUENTO -->
        <button v-if="puedeDescuentoProducto" :disabled="!cajaAbierta || !selectedItem" @click="abrirDescuentoProducto">
          Descuento Producto<br>[F8]
        </button>
        <button v-if="puedeDescuentoGeneral" :disabled="!cajaAbierta || productosLista.length === 0" @click="abrirDescuentoGeneral">
          Descuento General<br>[F9]
        </button>
        <button v-if="devolucionesEnabled && puedeNC" :disabled="!cajaAbierta" @click="abrirModalNC" class="btn-aplicar-nc">
          <i class="bi bi-receipt-cutoff"></i> Aplicar NC
          <span v-if="ncsAplicadas.length" class="nc-badge-btn">{{ ncsAplicadas.length }}</span>
        </button>
        <button :disabled="!cajaAbierta || cargandoProducto" @click="openPagoModal" :title="cargandoProducto ? 'Verificando stock...' : ''">
          Registrar Pago <br />
          [F12]
        </button>
     <RegistrarPagoModal
  :isVisible="isPagoModalVisible"
  :factura="factura"
  :clienteSeleccionado="clienteSeleccionado"
  :id_usuario="id_usuario"
  @close="closePagoModal"
  @confirm-payment="realizarPago"
  @modal-focused="handleModalFocus"
/>
        <button v-if="cotizacionesEnabled && puedeCotizaciones" :disabled="!cajaAbierta" @click="abrirModalCotizaciones">
          Cotizaciones<br />pendientes
        </button>
        <button @click="salir">Salir<br />[ALT] + [S]</button>
        <LogoutConfirmModal
          :isVisible="showConfirmModal"
          @confirm="logout"
          @cancel="cancelarSalir"
        />
      </div>
    </div>

    <!-- BOTÓN DARK/LIGHT MODE -->
    <button class="help-fab" @click="toggleTheme" :title="isDark ? 'Modo claro' : 'Modo oscuro'">
      <i class="bi" :class="isDark ? 'bi-brightness-high-fill' : 'bi-moon-stars-fill'"></i>
    </button>

    <!-- MODAL AYUDA CAJERO -->
    <div v-if="showHelpModal" class="help-overlay" @keydown.esc="showHelpModal = false">
      <div class="help-modal" tabindex="-1">
        <button class="modal-close-x" @click="showHelpModal = false">✕</button>
        <div class="help-header">
          <i class="bi bi-book-fill"></i>
          <h2>Guía del Cajero</h2>
        </div>
        <div class="help-body">

          <div class="help-section">
            <h3><span class="help-num">1</span> Los botones de abajo</h3>
            <table class="help-table">
              <tbody>
                <tr><td class="key">F2</td><td>Buscar producto por nombre o código</td></tr>
                <tr><td class="key">F3</td><td>Seleccionar cliente (para factura con RTN)</td></tr>
                <tr><td class="key warn">F4</td><td>Eliminar el producto seleccionado <em>(pide clave de admin)</em></td></tr>
                <tr><td class="key warn">F5</td><td>Limpiar toda la pantalla <em>(pide clave de admin)</em></td></tr>
                <tr><td class="key">F6</td><td>Guardar la venta en curso para atender a otro cliente</td></tr>
                <tr><td class="key">F7</td><td>Recuperar una venta guardada previamente</td></tr>
                <tr><td class="key">F8</td><td>Descuento a un producto específico (selecciónalo primero con doble clic)</td></tr>
                <tr><td class="key">F9</td><td>Descuento a toda la venta completa</td></tr>
                <tr><td class="key green">F12</td><td>Registrar el pago — abre la ventana de cobro</td></tr>
                <tr><td class="key">ALT+S</td><td>Cerrar sesión</td></tr>
              </tbody>
            </table>
            <p class="help-tip">💡 Para seleccionar un producto en la tabla: haz <strong>doble clic</strong> sobre su fila. Luego puedes presionar F4 o F8.</p>
          </div>

          <div class="help-section">
            <h3><span class="help-num">2</span> Cómo hacer una venta</h3>
            <ol class="help-ol">
              <li>Asegúrate de que la caja esté abierta (si los botones están grises, abre la caja primero).</li>
              <li>Escribe el nombre o código del producto en el recuadro de búsqueda (derecha arriba) y presiona Enter.</li>
              <li>Si el cliente lleva más de 1 unidad, escribe la cantidad seguida de <code>*</code> y luego el producto. Ejemplo: <code>3*jugo</code> Enter.</li>
              <li>Repite para cada producto.</li>
              <li>Si el cliente quiere factura con sus datos, presiona <strong>F3</strong> y busca su nombre o RTN.</li>
              <li>Presiona <strong>F12</strong> para cobrar. Elige efectivo o tarjeta y confirma.</li>
            </ol>
          </div>

          <div class="help-section">
            <h3><span class="help-num">3</span> Cómo abrir y cerrar la caja</h3>
            <ol class="help-ol">
              <li><strong>Abrir caja:</strong> haz clic en "Abrir caja" (parte derecha de la pantalla). Escribe el monto en efectivo disponible y confirma.</li>
              <li><strong>Cerrar caja:</strong> haz clic en "Cerrar caja" (en rojo). El sistema muestra el resumen del día. Cuenta el dinero físico, escríbelo y confirma.</li>
            </ol>
            <p class="help-warn">⚠️ F4 y F5 requieren contraseña de administrador. Sin esa clave no funcionan.</p>
          </div>

          <div class="help-section">
            <h3><span class="help-num">4</span> Cómo aplicar una Nota de Crédito (NC)</h3>
            <p style="margin:0 0 10px;font-size:13.5px;color:inherit;opacity:.85">Una NC es un crédito del sistema que el cliente ganó por una devolución anterior. Al aplicarla, el total de la venta se reduce automáticamente.</p>
            <ol class="help-ol">
              <li>Agrega los productos al carrito normalmente.</li>
              <li>Presiona el botón <strong>"Aplicar NC"</strong> en la barra inferior <span style="opacity:.7">(al lado de Descuento General)</span>.</li>
              <li>En el modal verás las Notas de Crédito disponibles del sistema. Haz clic en la(s) que quieras usar para seleccionarlas.</li>
              <li>Presiona <strong>"Aplicar descuento"</strong>. El total se reduce de inmediato.</li>
              <li>Continúa con el cobro normal presionando <strong>F12</strong>.</li>
            </ol>
            <p class="help-tip">💡 <strong>¿Te equivocaste de NC?</strong> Vuelve a presionar "Aplicar NC", deselecciona la que pusiste y elige la correcta — el sistema recalcula desde cero.</p>
            <p class="help-tip">💡 También puedes seleccionar la NC <em>antes</em> de agregar los productos. Al escanear el primer artículo el descuento se aplica solo.</p>
            <p class="help-warn">⚠️ Si el valor de la NC es mayor al total del carrito, el sistema la aplica parcialmente (te avisa con un mensaje en amarillo). El resto del saldo de la NC queda disponible para la próxima venta.</p>
          </div>

        </div>
      </div>
    </div>

    <!-- MODAL COTIZACIONES PENDIENTES -->
    <div v-if="isCotizacionesModalVisible" class="cot-overlay" @keydown.esc="isCotizacionesModalVisible = false">
      <div class="cot-modal" tabindex="-1" ref="cotModal">
        <button class="modal-close-x" @click="isCotizacionesModalVisible = false">✕</button>
        <div class="cot-header">
          <h3>Cotizaciones Aceptadas</h3>
        </div>
        <div class="cot-body">
          <p v-if="!cotizacionesPendientes.length" class="cot-empty">No hay cotizaciones aceptadas.</p>
          <table v-else class="cot-table">
            <thead>
              <tr>
                <th>Número</th>
                <th>Cliente</th>
                <th>Fecha</th>
                <th>Total</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in cotizacionesPendientes" :key="c.id_cotizacion">
                <td>{{ c.numero_cotizacion }}</td>
                <td>{{ c.Clientes?.nombre_completo || 'Consumidor Final' }}</td>
                <td>{{ c.created_at ? new Date(c.created_at).toLocaleDateString('es-HN') : '—' }}</td>
                <td>L. {{ Number(c.total || 0).toLocaleString('es-HN', { minimumFractionDigits: 2 }) }}</td>
                <td>
                  <button class="cot-btn-facturar"
                    :disabled="facturandoCot === c.id_cotizacion"
                    @click="facturarDesdeCotizacion(c)">
                    {{ facturandoCot === c.id_cotizacion ? 'Cargando...' : 'Facturar' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ═══ MODAL APLICAR NOTA DE CRÉDITO ═══════════════════════ -->
    <div v-if="modalNC.visible" class="help-overlay">
      <div class="modal-box nc-modal-box">
        <h3 class="nc-modal-title">
          <i class="bi bi-receipt-cutoff"></i> Notas de Crédito disponibles
          <button class="modal-close-x" @click="cerrarModalNC" style="margin-left:auto">✕</button>
        </h3>

        <!-- Estado cargando -->
        <div v-if="modalNC.cargando" class="nc-loading" style="padding:24px">
          <i class="bi bi-hourglass-split"></i> Cargando…
        </div>

        <template v-else>
          <!-- Sin NCs -->
          <div v-if="modalNC.ncs.length === 0 && !modalNC.error" class="nc-empty">
            <i class="bi bi-inbox" style="font-size:28px;opacity:.4"></i>
            <p>No hay notas de crédito registradas para esta sucursal.</p>
          </div>

          <!-- Lista de NCs -->
          <template v-else>
            <!-- Filtro — solo visible si hay más de 4 -->
            <div v-if="modalNC.ncs.length > 4" style="padding:0 24px;margin-bottom:4px">
              <input v-model="modalNC.busqueda" class="nc-filter-input"
                     placeholder="Filtrar por número o motivo…"
                     list="nc-datalist" />
              <datalist id="nc-datalist">
                <option v-for="n in modalNC.ncs" :key="n.id_devolucion" :value="n.numero_nota_credito" />
              </datalist>
            </div>

            <!-- NCs seleccionadas (resumen) -->
            <div v-if="ncsAplicadas.length" style="padding:0 24px 8px;border-bottom:1px solid #eee;margin-bottom:4px">
              <div style="font-size:11px;font-weight:700;color:#888;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Seleccionadas ({{ ncsAplicadas.length }})</div>
              <div v-for="nc in ncsAplicadas" :key="nc.id_devolucion"
                   style="display:flex;align-items:center;justify-content:space-between;padding:4px 0;gap:8px">
                <span style="font-size:13px;font-weight:600;color:#c09d62">{{ nc.numero_nota_credito }}</span>
                <span style="font-size:13px">L. {{ Number(nc.monto_devuelto).toFixed(2) }}</span>
                <button @click="toggleSeleccionNC(nc)" style="background:none;border:none;color:#dc3545;cursor:pointer;padding:0 2px">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div style="border-top:1px dashed #eee;padding-top:6px;margin-top:4px;display:flex;justify-content:space-between;font-weight:700">
                <span style="font-size:12px;color:#555">Total NC</span>
                <span style="color:#c09d62">L. {{ ncTotalSeleccionado.toFixed(2) }}</span>
              </div>
              <template v-if="productosLista.length > 0 && ncMontoAplicable < ncTotalSeleccionado">
                <div style="font-size:11px;color:#999;text-align:right;margin-top:2px">
                  Se aplicará L. {{ ncMontoAplicable.toFixed(2) }} (total carrito)
                </div>
              </template>
            </div>

            <div class="nc-list">
              <div v-for="nc in ncsFiltradas" :key="nc.id_devolucion"
                   class="nc-list-item" :class="{ 'nc-list-item-sel': nc._seleccionada }"
                   @click="toggleSeleccionNC(nc)">
                <i :class="nc._seleccionada ? 'bi bi-check-square-fill' : 'bi bi-square'"
                   style="margin-right:8px;flex-shrink:0" :style="nc._seleccionada ? 'color:#c09d62' : 'color:#ccc'"></i>
                <div class="nc-list-left">
                  <span class="nc-list-num">{{ nc.numero_nota_credito }}</span>
                  <span v-if="nc.motivo" class="nc-list-motivo">{{ nc.motivo }}</span>
                </div>
                <div class="nc-list-right">
                  <span class="nc-list-monto">L. {{ Number(nc.monto_devuelto).toFixed(2) }}</span>
                  <span class="nc-list-fecha">{{ fmtFechaNC(nc.created_at) }}</span>
                </div>
              </div>
              <div v-if="ncsFiltradas.length === 0" class="nc-empty">
                <p>Sin coincidencias para "{{ modalNC.busqueda }}"</p>
              </div>
            </div>
          </template>

          <p v-if="modalNC.error" style="color:#dc3545;font-size:13px;margin:8px 0 0">{{ modalNC.error }}</p>
        </template>

        <div v-if="!modalNC.cargando" style="padding-bottom:4px">
          <div class="nc-modal-footer" style="padding:8px 24px 0">
            <button @click="cerrarModalNC" class="nc-btn-back">
              <i class="bi bi-x"></i> Cerrar
            </button>
            <button @click="aplicarNCAlCarrito"
                    :disabled="!ncsAplicadas.length || productosLista.length === 0"
                    class="nc-btn-apply">
              <i class="bi bi-check-lg"></i>
              {{ ncsAplicadas.length > 0 && ncMontoAplicable < ncTotalSeleccionado ? 'Aplicar (parcial)' : 'Aplicar descuento' }}
            </button>
          </div>
          <p v-if="productosLista.length === 0" style="color:#ffc107;font-size:12px;margin:6px 24px 0;display:flex;gap:4px">
            <i class="bi bi-exclamation-triangle"></i> Agrega productos al carrito antes de aplicar.
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import ClienteModal from "../components/modalesCrearVenta/ClienteModal.vue";
import RegistrarPagoModal from "../components/modalesCrearVenta/RegistrarPagoModal.vue";
import EliminarItemsModal from "../components/modalesCrearVenta/EliminarItemsModal.vue";
import BuscarProductoModal from "../components/modalesCrearVenta/BuscarProductoModal.vue";
import DescuentoProductoModal from "../components/modalesCrearVenta/DescuentoProductoModal.vue";
import DescuentoGeneralModal from "../components/modalesCrearVenta/DescuentoGeneralModal.vue";
import { useToast } from "vue-toastification";
import { notificaciones, notis } from "../../services/notificaciones.js";
import ModalLoading from "@/components/ModalLoading.vue";
import GuardarVentaModal from "@/components/modalesCrearVenta/GuardarVentaModal.vue";
import RecuperarVentaModal from "@/components/modalesCrearVenta/RecuperarVentaModal.vue";
import PaymentAnimationModal from "@/components/PaymentAnimationModal.vue";
import AperturaCajaModal from "@/components/modalesCrearVenta/AperturaCajaModal.vue";
import solicitudes from "../../services/solicitudes.js";
import LimpiarPantallaModal from "@/components/modalesCrearVenta/LimpiarPantallaModal.vue";
import LogoutConfirmModal from "@/components/LogoutConfirmModal.vue";

import {
  getInfoBasic,
  getProductos,
  agregarProductoCodigo,
  getVentaPendiente,
  guardarVenta,
  getVentasGuardadas,
  getRecProductoVenta,
  postVenta,
  eliminarVenta,
  eliminarProductoVenta,
  cajaUsuario,
  createCaja,
  pagar,
  pagarTranferir,
  pagarMixto,
  registrarVentaCredito, // NUEVA IMPORTACIÓN
} from "../../services/ventasSolicitudes.js";

import FacturaModal from "@/components/FacturaModal.vue";
import CerrarCajaModal from "@/components/CierreCajaModal.vue";
const {
  getClientesbyEmpresa,
} = require("../../services/clienteSolicitudes.js");
const { sucursalSar } = require("../../services/sucursalesSolicitudes.js");
import { setPageTitle } from "@/components/pageMetadata";
import { getCotizaciones, getDetalleCotizacion, actualizarEstadoCotizacion, buscarNC, getNCDisponibles } from "../../services/featuresSolicitudes.js";
import { isRouteEnabled } from "@/utils/planUtils";
const { getSocket } = require('@/services/socket');
import { hasAccionPermiso } from "../../services/permisos.js";

export default {
  components: {
    ClienteModal,
    LogoutConfirmModal,
    AperturaCajaModal,
    PaymentAnimationModal,
    RegistrarPagoModal,
    EliminarItemsModal,
    LimpiarPantallaModal,
    BuscarProductoModal,
    DescuentoProductoModal,
    DescuentoGeneralModal,
    ModalLoading,
    GuardarVentaModal,
    RecuperarVentaModal,
    FacturaModal,
    CerrarCajaModal,
  },
  data() {
    return {
      isAperturaCajaModalVisible: false,
      showConfirmModal: false,
      isLimpiarPantallaModalVisible: false,
      itemTemp: null,
      estadoCajaValidado: false,
      isCerrarCajaModalVisible: false,
      isFacturaModalVisible: false,
      facturaActual: "",
      cajaAbierta: false,
      numTicket: "000-001-01-00000001",
      fecha: new Date().toLocaleDateString(),
      addQuery: "",
      totalCantidad: "",
      id_usuario: 0,
      totalEfectivo: 0,
      totalTransferencia: 0,
      prueba: "prueba",
      info: "",
      isBuscarProductoModalVisible: false,
      isEditing: false,
      isModalVisible: false,
      isPagoModalVisible: false,
      isAnyModalOpen: false,
      clienteSeleccionado: null,
      selectedItem: null,
      isEliminarModalVisible: false,
      isModalFocused: false,
      productos: [],
      productosLista: [],
      clientes: [],
      venta: [],
      factura: [],
      usaSAR: false,
      isModalLoading: false,
      loadingMessage: "",
      recuperandoVenta: false,
      cargandoProducto: false, // Bloquea el modal de pago mientras se verifica stock
      isGuardarVentaModalVisible: false,
      isRecuperarVentaModalVisible: false,
      ventaPendiente: false,
      isPaymentAnimationVisible: false,
      // NUEVAS VARIABLES PARA DESCUENTOS
      isDescuentoProductoModalVisible: false,
      isDescuentoGeneralModalVisible: false,
      descuentoGeneralAplicado: 0,
      descuentoClientePct: 0,

      // Nota de Crédito (multi-NC)
      ncsAplicadas: [],
      modalNC: { visible: false, busqueda: '', buscando: false, error: '', ncs: [], cargando: false },
      // Notificación de anulación
      notifAnulacion: null,
      // COTIZACIONES PENDIENTES
      showHelpModal: false,
      isDark: localStorage.getItem('isDarkMode') === 'true',
      profileDropdownOpen: false,
      showCuentaModal: false,
      perfil: { nombre: '', apellido: '', nombre_usuario: '' },
      cuentaForm: { nombre_usuario: '', contrasena: '', contrasena_nueva: '', contrasena_confirm: '' },
      cuentaLoading: false,
      isCotizacionesModalVisible: false,
      cotizacionesPendientes: [],
      facturandoCot: null,
      cotizacionEnCurso: null,
    };
  },

  watch: {
    isFacturaModalVisible(newVal) {
      this.isAnyModalOpen = newVal;
      if (newVal) {
        this.pauseMainKeyboardEvents();
      } else {
        this.resumeMainKeyboardEvents();
      }
    },

    showConfirmModal(newVal) {
      this.isAnyModalOpen = newVal;
      if (newVal) {
        this.pauseMainKeyboardEvents();
      } else {
        this.resumeMainKeyboardEvents();
      }
    },

    isModalVisible(newVal) {
      this.isAnyModalOpen = newVal;
      if (newVal) {
        this.isPagoModalVisible = false;
        this.pauseMainKeyboardEvents();
      } else {
        this.resumeMainKeyboardEvents();
      }
    },

    isPagoModalVisible(newVal) {
      this.isAnyModalOpen = newVal;
      if (newVal) {
        this.isModalVisible = false;
        this.pauseMainKeyboardEvents();
      } else {
        this.resumeMainKeyboardEvents();
      }
    },

    isBuscarProductoModalVisible(newVal) {
      this.isAnyModalOpen = newVal;
      if (newVal) {
        this.pauseMainKeyboardEvents();
      } else {
        this.resumeMainKeyboardEvents();
      }
    },

    isCerrarCajaModalVisible(newVal) {
      this.isAnyModalOpen = newVal;
      if (newVal) {
        this.pauseMainKeyboardEvents();
      } else {
        this.resumeMainKeyboardEvents();
      }
    },

    // NUEVOS WATCHERS PARA MODALES DE DESCUENTO
    isDescuentoProductoModalVisible(newVal) {
      this.isAnyModalOpen = newVal;
      if (newVal) {
        this.pauseMainKeyboardEvents();
      } else {
        this.resumeMainKeyboardEvents();
      }
    },

    isDescuentoGeneralModalVisible(newVal) {
      this.isAnyModalOpen = newVal;
      if (newVal) {
        this.pauseMainKeyboardEvents();
      } else {
        this.resumeMainKeyboardEvents();
      }
    },

    // Recalcular totales cuando cambie el cliente o los productos
    clienteSeleccionado: {
      handler() {
        this.recalcularTodosLosProductos();
      },
      deep: true
    },

    productosLista: {
      handler() {
        this.recalcularTodosLosProductos();
      },
      deep: true
    },

    // Auto-aplicar NCs seleccionadas cuando se agrega el primer producto al carrito
    'productosLista.length'(newLen, oldLen) {
      if (newLen > 0 && newLen > oldLen && this.ncsAplicadas.length > 0 && this.descuentoGeneralAplicado === 0) {
        this.aplicarNCAlCarrito();
      }
      // Auto-aplicar descuento del cliente cuando se agrega el primer producto
      if (newLen === 1 && oldLen === 0 && this.descuentoClientePct > 0 && this.descuentoGeneralAplicado === 0) {
        this.$nextTick(() => this.aplicarDescuentoCliente());
      }
    }
  },

  computed: {
    isAdminEnCaja() {
      const role = localStorage.getItem('role');
      return role === '1' || role === '4';
    },
    sucursalNombre() {
      // Si Admin/CEO eligió una sucursal específica, mostrarla; si no, la del usuario
      if (this.isAdminEnCaja) {
        try {
          const override = JSON.parse(localStorage.getItem('caja_sucursal_override') || 'null');
          if (override?.nombre_administrativo) return override.nombre_administrativo;
        } catch { /* */ }
      }
      return this.info?.nombreSucursal || '';
    },
    ncsFiltradas() {
      const q = this.modalNC.busqueda.trim().toLowerCase();
      const ncs = q
        ? this.modalNC.ncs.filter(n =>
            n.numero_nota_credito?.toLowerCase().includes(q) ||
            n.motivo?.toLowerCase().includes(q))
        : this.modalNC.ncs;
      // Marcar cuáles ya están seleccionadas
      const selIds = new Set(this.ncsAplicadas.map(n => n.id_devolucion));
      return ncs.map(n => ({ ...n, _seleccionada: selIds.has(n.id_devolucion) }));
    },
    totalCarritoNum() {
      return this.productosLista.reduce((t, p) => t + p.precio_final, 0);
    },
    ncTotalSeleccionado() {
      return this.ncsAplicadas.reduce((s, n) => s + Number(n.monto_devuelto), 0);
    },
    ncMontoAplicable() {
      return Math.min(this.ncTotalSeleccionado, this.totalCarritoNum);
    },
    cotizacionesEnabled()  { return isRouteEnabled('/cotizaciones'); },
    devolucionesEnabled()  { return isRouteEnabled('/devoluciones'); },
    puedeDescuentoGeneral()  { return hasAccionPermiso('ventas_descuento_general'); },
    puedeDescuentoProducto() { return hasAccionPermiso('ventas_descuento_producto'); },
    puedeNC()                { return hasAccionPermiso('ventas_nc'); },
    puedeCotizaciones()      { return hasAccionPermiso('ventas_cotizaciones'); },
    puedeCrearCliente()      { return hasAccionPermiso('ventas_crear_cliente'); },
    userInitials() {
      return ((this.perfil.nombre?.[0] || '') + (this.perfil.apellido?.[0] || '')).toUpperCase() || '?';
    },
    calcularTotal() {
      const total = this.productosLista.reduce(
        (total, p) => total + p.precio_final,
        0
      );
      return total.toLocaleString("es-HN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    totalDescuentoTerceraEdad() {
      if (!this.clienteSeleccionado?.es_tercera_edad) return 0;
      
      return this.productosLista.reduce((total, producto) => {
        return total + (producto.descuento_tercera_edad || 0);
      }, 0);
    },

    // NUEVO COMPUTED PARA DESCUENTO GENERAL
    calcularTotalSinDescuentoGeneral() {
      return this.productosLista.reduce((total, p) => {
        // Calcular sin descuento general
        const precioSinDescuentoGeneral = p.precio_final + (p.descuento_general || 0);
        return total + precioSinDescuentoGeneral;
      }, 0);
    },

    sucursalActivaFactura() {
      return this.usaSAR && this.cajaAbierta;
    },

    isCajaAbierta() {
      return this.cajaAbierta;
    },
  },

  methods: {
    volverAlPanel() {
      localStorage.removeItem('caja_sucursal_override');
      this.$router.push('/home');
    },
    toggleTheme() {
      this.isDark = !this.isDark;
      localStorage.setItem('isDarkMode', this.isDark);
      document.documentElement.classList.toggle('dark', this.isDark);
      window.dispatchEvent(new CustomEvent('poswave:toggle-dark'));
    },
    async fetchPerfil() {
      try {
        const token = localStorage.getItem('auth');
        const res = await axios.get(`${solicitudes.homeUrl}/perfil`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.perfil.nombre = res.data.nombre || '';
        this.perfil.apellido = res.data.apellido || '';
        this.perfil.nombre_usuario = res.data.nombre_usuario || '';
        this.cuentaForm.nombre_usuario = res.data.nombre_usuario || '';
      } catch (e) { console.error('perfil', e); }
    },
    openCuentaModal() {
      this.profileDropdownOpen = false;
      this.cuentaForm = { nombre_usuario: this.perfil.nombre_usuario, contrasena: '', contrasena_nueva: '', contrasena_confirm: '' };
      this.showCuentaModal = true;
    },
    closeCuentaModal() {
      this.showCuentaModal = false;
    },
    async saveCuenta() {
      const isPassChange = this.cuentaForm.contrasena || this.cuentaForm.contrasena_nueva || this.cuentaForm.contrasena_confirm;
      if (isPassChange) {
        if (!this.cuentaForm.contrasena) { notis('error', 'Ingresa tu contraseña actual'); return; }
        if (!this.cuentaForm.contrasena_nueva) { notis('error', 'Ingresa la contraseña nueva'); return; }
        if (this.cuentaForm.contrasena_nueva !== this.cuentaForm.contrasena_confirm) { notis('error', 'Las contraseñas nuevas no coinciden'); return; }
        if (this.cuentaForm.contrasena_nueva.length < 8) { notis('error', 'La contraseña nueva debe tener al menos 8 caracteres'); return; }
      }
      this.cuentaLoading = true;
      try {
        const token = localStorage.getItem('auth');
        if (isPassChange) {
          const verif = await axios.post(`${solicitudes.homeUrl}/verificar-password`, {
            contraseña: this.cuentaForm.contrasena,
            id_usuario: this.id_usuario,
          }, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
          if (!verif.data?.isValid) { notis('error', verif.data?.message || 'Contraseña actual incorrecta'); return; }
        }
        const payload = { nombre_usuario: this.cuentaForm.nombre_usuario };
        if (isPassChange) {
          payload.contraseña_actual = this.cuentaForm.contrasena;
          payload.contraseña_nueva = this.cuentaForm.contrasena_nueva;
          payload.contraseña_confirm = this.cuentaForm.contrasena_confirm;
        }
        const res = await axios.put(`${solicitudes.homeUrl}/configuser`, payload, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (res.status === 200) {
          notis('success', 'Datos actualizados correctamente');
          this.perfil.nombre_usuario = this.cuentaForm.nombre_usuario;
          this.closeCuentaModal();
        }
      } catch (e) {
        notis('error', e.response?.data?.message || 'Error al guardar cambios');
      } finally {
        this.cuentaLoading = false;
      }
    },
    onUsrClickOutside(e) {
      if (this.$refs.usrDropRef && !this.$refs.usrDropRef.contains(e.target)) {
        this.profileDropdownOpen = false;
      }
    },
    // FUNCIÓN: Calcular impuesto basado en el ID
    calcularImpuestoPorId(precio, impuestoId) {
      let porcentajeImpuesto = 0;
      
      switch(impuestoId) {
        case 1: // IMPUESTO_ISV_15
          porcentajeImpuesto = 0.15;
          break;
        case 2: // IMPUESTO_ISV_18
          porcentajeImpuesto = 0.18;
          break;
        case 3: // IMPUESTO_EXTENTO
          porcentajeImpuesto = 0;
          break;
        default:
          porcentajeImpuesto = 0;
      }
      
      return precio + (precio * porcentajeImpuesto);
    },

// MÉTODO SAR CORRECTO: calcularImporte
calcularImporte(producto) {
  let precioBaseSinImpuesto;
  let descuentoMostrarSolo = 0; // Solo para mostrar, NO para restar
  let descuentosReales = 0; // Descuentos que SÍ se restan
  let esPrecioMayorista = false;
  
  // 1. Determinar precio base SIN IMPUESTO
  if (
    producto.precio_mayorista > 0 &&
    producto.cantidad_activar_mayorista > 0 &&
    producto.cantidad >= producto.cantidad_activar_mayorista
  ) {
    precioBaseSinImpuesto = producto.cantidad * producto.precio_mayorista;
    esPrecioMayorista = true;
    
    // DESCUENTO MAYORISTA: Solo para mostrar, NO se resta
    const precioNormalSinImpuesto = producto.cantidad * producto.precio_unitario;
    descuentoMostrarSolo = precioNormalSinImpuesto - precioBaseSinImpuesto;
  } else {
    precioBaseSinImpuesto = producto.cantidad * producto.precio_unitario;
    
    // Descuento promocional SÍ se resta
    if (producto.precioDescuento > 0) {
      descuentosReales += producto.precioDescuento * producto.cantidad;
    }
  }
  
  // 2. DESCUENTOS REALES que SÍ se restan
  let descuentoTerceraEdad = 0;
  
  // Descuento tercera edad SÍ se resta
  if (this.clienteSeleccionado?.es_tercera_edad) {
    descuentoTerceraEdad = precioBaseSinImpuesto * 0.20;
    descuentosReales += descuentoTerceraEdad;
  }
  
  // Descuento manual SÍ se resta
  if (producto.descuento_manual && producto.descuento_manual > 0) {
    descuentosReales += producto.descuento_manual;
  }
  
  // DESCUENTO GENERAL SÍ se resta - ESTA ERA LA LÍNEA QUE FALTABA
  if (producto.descuento_general && producto.descuento_general > 0) {
    descuentosReales += producto.descuento_general;
  }

  // 3. Aplicar SOLO los descuentos reales
  const precioConDescuentosReales = precioBaseSinImpuesto - descuentosReales;

  // 4. APLICAR IMPUESTO
  const precioFinalConImpuesto = this.calcularImpuestoPorId(precioConDescuentosReales, producto.impuesto);

  // Guardar información
  producto.descuento_tercera_edad = descuentoTerceraEdad;
  const soloPromoDescuento = (!esPrecioMayorista && producto.precioDescuento > 0)
    ? producto.precioDescuento * producto.cantidad : 0;
  producto.descuento_promociones = soloPromoDescuento;
  producto.descuento_mayorista_info = descuentoMostrarSolo;
  producto.precio_final = +precioFinalConImpuesto.toFixed(2);
  producto.es_precio_mayorista = esPrecioMayorista;
  producto.descuento_total_frontend = descuentosReales; // INCLUYE descuento general
  
  return producto.precio_final.toFixed(2);
},

    // MÉTODO MODIFICADO: calcularDescuento incluyendo tercera edad y descuento manual
calcularDescuento(producto) {
  let descuentoParaMostrar = 0;
  
  // Para mayorista: mostrar el "ahorro" pero no es descuento real
  if (producto.es_precio_mayorista && producto.descuento_mayorista_info) {
    descuentoParaMostrar += producto.descuento_mayorista_info;
  }
  
  // Descuentos reales
  if (producto.descuento_tercera_edad) {
    descuentoParaMostrar += producto.descuento_tercera_edad;
  }
  if (producto.descuento_manual) {
    descuentoParaMostrar += producto.descuento_manual;
  }
  if (producto.descuento_general) {
    descuentoParaMostrar += producto.descuento_general;
  }
  if (!producto.es_precio_mayorista && producto.precioDescuento > 0) {
    descuentoParaMostrar += producto.precioDescuento * producto.cantidad;
  }
  
  return descuentoParaMostrar > 0 ? descuentoParaMostrar.toFixed(2) : "-";
},


    // NUEVO MÉTODO: obtenerTipoDescuento modificado
    obtenerTipoDescuento(producto) {
      const tiposDescuento = [];
      
      // Verificar descuento por promoción
      if (!producto.es_precio_mayorista && producto.precioDescuento > 0) {
        tiposDescuento.push('Promo');
      }
      
      // Verificar descuento mayorista
      if (producto.es_precio_mayorista) {
        tiposDescuento.push('Mayor');
      }
      
      // Verificar descuento tercera edad
      if (this.clienteSeleccionado?.es_tercera_edad) {
        tiposDescuento.push('3ra Edad');
      }

      // Verificar descuento manual
      if (producto.descuento_manual && producto.descuento_manual > 0) {
        tiposDescuento.push('Manual');
      }

      // Verificar descuento general
      if (producto.descuento_general && producto.descuento_general > 0) {
        tiposDescuento.push('General');
      }
      
      return tiposDescuento.length > 0 ? tiposDescuento.join(', ') : '-';
    },

    // ─── NOTA DE CRÉDITO (multi-NC) ──────────────────────────────
    async abrirModalNC() {
      this.modalNC = { visible: true, busqueda: '', buscando: false, error: '', ncs: [], cargando: true };
      try {
        const res = await getNCDisponibles(this.id_usuario);
        this.modalNC.ncs = Array.isArray(res) ? res : (res?.data || []);
      } catch (e) {
        this.modalNC.error = 'Error al cargar notas de crédito.';
      } finally {
        this.modalNC.cargando = false;
      }
    },
    cerrarModalNC() {
      this.modalNC.visible = false;
    },
    toggleSeleccionNC(nc) {
      const idx = this.ncsAplicadas.findIndex(n => n.id_devolucion === nc.id_devolucion);
      if (idx >= 0) {
        this.ncsAplicadas.splice(idx, 1);
      } else {
        this.ncsAplicadas.push(nc);
      }
    },
    async buscarNCModal() {
      if (!this.modalNC.busqueda.trim()) return;
      const existente = this.modalNC.ncs.find(n =>
        n.numero_nota_credito?.toLowerCase() === this.modalNC.busqueda.trim().toLowerCase()
      );
      if (existente) { this.toggleSeleccionNC(existente); return; }
      this.modalNC.buscando = true;
      this.modalNC.error = '';
      try {
        const res = await buscarNC(this.modalNC.busqueda.trim(), this.id_usuario);
        // Agregar a la lista si no está
        if (res.data && !this.modalNC.ncs.find(n => n.id_devolucion === res.data.id_devolucion)) {
          this.modalNC.ncs.unshift(res.data);
        }
        this.toggleSeleccionNC(res.data);
      } catch (e) {
        this.modalNC.error = e.message?.includes('404') || e.message?.includes('no encontrada')
          ? 'Nota de crédito no encontrada.'
          : 'Error al buscar: ' + e.message;
      } finally {
        this.modalNC.buscando = false;
      }
    },
    aplicarNCAlCarrito() {
      if (!this.ncsAplicadas.length) return;

      // Resetear descuento_general previo para calcular siempre sobre precios originales.
      // Sin esto, precio_final ya viene reducido por la NC anterior y el factor
      // totalSinImpuesto/totalConImpuesto supera 1, causando descuentos incorrectos
      // al cambiar de NC o re-aplicar.
      if (this.descuentoGeneralAplicado > 0) {
        this.productosLista.forEach(p => { p.descuento_general = 0; });
        this.descuentoGeneralAplicado = 0;
        this.recalcularTodosLosProductos();
      }

      const totalConImpuesto = this.productosLista.reduce((t, p) => t + p.precio_final, 0);
      const totalSinImpuesto = this.productosLista.reduce((t, p) => {
        const base = (p.precio_mayorista > 0 && p.cantidad_activar_mayorista > 0 && p.cantidad >= p.cantidad_activar_mayorista)
          ? p.cantidad * p.precio_mayorista
          : p.cantidad * p.precio_unitario;
        return t + base;
      }, 0);
      const montoNC        = this.ncTotalSeleccionado;
      const montoAplicado  = Math.min(montoNC, totalConImpuesto);
      const factor         = totalConImpuesto > 0 ? totalSinImpuesto / totalConImpuesto : 1;
      const descuentoPreTax = Math.min(montoAplicado * factor, totalSinImpuesto);
      this.handleDescuentoGeneral({ descuentoCalculado: descuentoPreTax });
      this.cerrarModalNC();
      if (montoAplicado < montoNC) {
        notis('warning', `${this.ncsAplicadas.length} NC aplicadas parcialmente — L. ${montoAplicado.toFixed(2)} de L. ${montoNC.toFixed(2)}`);
      } else {
        notis('success', `${this.ncsAplicadas.length} NC aplicada(s): L. ${montoAplicado.toFixed(2)}`);
      }
    },
    fmtFechaNC(s) {
      return s ? new Date(s).toLocaleDateString('es-HN') : '—';
    },

    // MÉTODO CORREGIDO: mostrarPrecioFinal (para la columna "Precio" - SIN impuesto)
    mostrarPrecioFinal(producto) {
      // Mostrar precio unitario SIN impuesto
      if (
        producto.precio_mayorista > 0 &&
        producto.cantidad_activar_mayorista > 0 &&
        producto.cantidad >= producto.cantidad_activar_mayorista
      ) {
        return producto.precio_mayorista.toFixed(2);
      } else {
        return producto.precio_unitario.toFixed(2);
      }
    },

  // MÉTODO MODIFICADO: mostrarPrecioConImpuesto con tercera edad
mostrarPrecioConImpuesto(producto) {
  // Mostrar el subtotal: precio con descuentos + impuesto
  let precioBaseSinImpuesto;
  
  if (
    producto.precio_mayorista > 0 &&
    producto.cantidad_activar_mayorista > 0 &&
    producto.cantidad >= producto.cantidad_activar_mayorista
  ) {
    precioBaseSinImpuesto = producto.cantidad * producto.precio_mayorista;
  } else {
    precioBaseSinImpuesto = producto.cantidad * producto.precio_unitario;
  }

  // Calcular descuentos
  let descuentoTotal = 0;
  if (producto.descuento_promociones) descuentoTotal += producto.descuento_promociones;
  if (producto.descuento_tercera_edad) descuentoTotal += producto.descuento_tercera_edad;
  if (producto.descuento_manual) descuentoTotal += producto.descuento_manual;
  if (producto.descuento_general) descuentoTotal += producto.descuento_general;

  // Precio con descuentos sin impuesto
  const precioConDescuentosSinImpuesto = precioBaseSinImpuesto - descuentoTotal;
  
  // Aplicar impuesto
  const subtotalConImpuesto = this.calcularImpuestoPorId(precioConDescuentosSinImpuesto, producto.impuesto);
  
  return subtotalConImpuesto.toFixed(2);
},

   // NUEVO MÉTODO: Recalcular todos los productos cuando cambie el cliente
   recalcularTodosLosProductos() {
     this.productosLista.forEach(producto => {
       this.calcularImporte(producto);
     });
   },

   // NUEVOS MÉTODOS PARA DESCUENTOS
   abrirDescuentoProducto() {
     if (!this.selectedItem) {
       notis("info", "Seleccione un producto primero");
       return;
     }
     this.isDescuentoProductoModalVisible = true;
   },

   abrirDescuentoGeneral() {
     if (this.productosLista.length === 0) {
       notis("info", "No hay productos en la venta");
       return;
     }
     this.isDescuentoGeneralModalVisible = true;
   },

   handleDescuentoProducto(descuentoData) {
  if (!this.selectedItem) return;

  // El descuento se aplica sobre precio SIN impuesto
  this.selectedItem.descuento_manual = descuentoData.descuentoCalculado;
  
  // Recalcular totales
  this.recalcularTodosLosProductos();
  
  notis("success", `Descuento de L. ${descuentoData.descuentoCalculado.toFixed(2)} aplicado al producto`);
},

// MÉTODO: handleDescuentoGeneral
handleDescuentoGeneral(descuentoData) {
  this.descuentoGeneralAplicado = descuentoData.descuentoCalculado;
  
  // Aplicar proporcionalmente basado en precio SIN impuesto
  const totalSinImpuestoSinDescuentoGeneral = this.productosLista.reduce((total, producto) => {
    let precioBase;
    if (
      producto.precio_mayorista > 0 &&
      producto.cantidad_activar_mayorista > 0 &&
      producto.cantidad >= producto.cantidad_activar_mayorista
    ) {
      precioBase = producto.cantidad * producto.precio_mayorista;
    } else {
      precioBase = producto.cantidad * producto.precio_unitario;
    }
    return total + precioBase;
  }, 0);
  
  this.productosLista.forEach(producto => {
    let precioBase;
    if (
      producto.precio_mayorista > 0 &&
      producto.cantidad_activar_mayorista > 0 &&
      producto.cantidad >= producto.cantidad_activar_mayorista
    ) {
      precioBase = producto.cantidad * producto.precio_mayorista;
    } else {
      precioBase = producto.cantidad * producto.precio_unitario;
    }
    
    const porcentajeProducto = totalSinImpuestoSinDescuentoGeneral > 0 ? 
      precioBase / totalSinImpuestoSinDescuentoGeneral : 0;
    const descuentoParaEsteProducto = descuentoData.descuentoCalculado * porcentajeProducto;
    
    producto.descuento_general = descuentoParaEsteProducto;
  });

  // IMPORTANTE: Recalcular todos los productos
  this.recalcularTodosLosProductos();
  
  notis("success", `Descuento general de L. ${descuentoData.descuentoCalculado.toFixed(2)} aplicado`);
},

   abrirModalCerrarCaja() {
     this.isCerrarCajaModalVisible = true;
   },

   closeFacturaModal() {
     this.isFacturaModalVisible = false;
     this.$nextTick(() => {
       this.$refs.codigoRef?.focus();
     });
   },

   salir() {
     this.showConfirmModal = true;
   },

   cancelarSalir() {
     this.showConfirmModal = false;
   },

   abrirCaja() {
     this.isAperturaCajaModalVisible = true;
     this.pauseMainKeyboardEvents();
   },

   async confirmarCierreCaja(datosCierre) {
     this.isModalLoading = true;
     try {
       this.isModalLoading = true;
       this.loadingMessage = "Cerrando caja...";

       const url = `${solicitudes.homeUrl}/ventas/cerrar-caja/${this.id_usuario}`;

       const token = localStorage.getItem("auth");
       const response = await fetch(url, {
         method: "PATCH",
         headers: {
           "Content-Type": "application/json",
           Authorization: `Bearer ${token}`,
         },
         body: JSON.stringify({
           id_usuario: this.id_usuario,
           dineroCaja: datosCierre.dineroEnCaja,
         }),
       });

       if (!response.ok) {
         throw new Error(
           `Error del servidor: ${response.status} ${response.statusText}`
         );
       }

       const data = await response.json();

       if (data) {
         try {
           this.isModalLoading = true;
           await this.generarPDFCierreCaja(data);
           notis("success", "Caja cerrada y reporte generado exitosamente");
         } catch (pdfError) {
           console.error("Error al generar PDF:", pdfError);
           notis(
             "warning",
             "Caja cerrada pero hubo un error al generar el PDF"
           );
         } finally {
           this.isModalLoading = false;
         }
       }

       this.cajaAbierta = false;
       this.isCerrarCajaModalVisible = false;
     } catch (error) {
       console.error("Error al cerrar caja:", error);
       notis("error", "Error al cerrar caja");
     } finally {
       this.isModalLoading = false;
     }
   },

   async generarPDFCierreCaja(reporte) {
    this.isModalLoading = true;
    try {

      const url = `${solicitudes.homeUrl}/ventas/generar-pdf-cierre/${this.id_usuario}`;

      const token = localStorage.getItem("auth");
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(reporte),
      });


      if (!response.ok) {
        console.error(
          "Respuesta no exitosa:",
          response.status,
          response.statusText
        );
        const errorText = await response.text();
        console.error("Detalle del error:", errorText);
        throw new Error(
          `Error del servidor: ${response.status} ${response.statusText}`
        );
      }

      const blob = await response.blob();

      const url_blob = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url_blob;
      a.download = `cierre_caja_${
        new Date().toISOString().split("T")[0]
      }.pdf`;

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url_blob);
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error detallado en generarPDFCierreCaja:", {
        mensaje: error.message,
        error: error,
        stack: error.stack,
      });
      throw error;
    } finally {
      this.isModalLoading = false;
    }
  },

  async cerrarCaja() {
    this.isModalLoading = true;
    try {
      const { data: ventas } = await axios.get(
        `${solicitudes.homeUrl}/ventas/totales-caja/${this.id_usuario}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("auth")}`,
          },
        }
      );

      this.totalEfectivo = ventas.totalEfectivo;
      this.totalTransferencia = ventas.totalTransferencia;
      this.abrirModalCerrarCaja();
    } catch (error) {
      console.error("Error al obtener totales:", error);
      notis("error", "Error al obtener totales de caja");
    } finally {
      this.isModalLoading = false;
    }
  },

  async handleAperturaCaja(monto) {
    this.isModalLoading = true;
    try {
      this.loadingMessage = "Abriendo caja...";

      await new Promise((resolve) => setTimeout(resolve, 1000));
      await createCaja(this.id_usuario, monto);

      this.cajaAbierta = true;

      this.isAperturaCajaModalVisible = false;
      this.resumeMainKeyboardEvents();

      const toast = useToast();
      toast.success(`Caja abierta con monto inicial de L. ${monto}`);
    } catch (error) {
      const toast = useToast();
      toast.error("Error al abrir la caja");
    } finally {
      this.isModalLoading = false;
    }
  },

  async buscarProducto() {
    this.isModalLoading = true;
    this.loadingMessage = "Cargando productos...";
    try {
      const productosRaw = await getProductos(this.id_usuario);
     this.productos = productosRaw
       .filter(producto => producto.tipo !== 'materia_prima')
       .map(producto => ({
         ...producto,
         precioImpuesto: this.calcularImpuestoPorId(producto.precio_unitario, producto.impuesto),
         precioImpuestoMayorista: producto.precio_mayorista
           ? this.calcularImpuestoPorId(producto.precio_mayorista, producto.impuesto)
           : 0
       }));
     this.isBuscarProductoModalVisible = true;
   } finally {
     this.isModalLoading = false;
   }
 },

 closeBuscarProductoModal() {
   this.isBuscarProductoModalVisible = false;
   this.$nextTick(() => {
     this.$refs.codigoRef?.focus();
   });
 },

 async handleProductSelected(product) {
   this.addQuery = product.codigo_producto;
   this.totalCantidad = product.cantidad;
   await this.agregarProducto();

   this.closeBuscarProductoModal();
 },

 handleCantidadFocus() {
   this.pauseMainKeyboardEvents();
 },

 handleCantidadBlur() {
   this.$nextTick(() => {
     if (this.totalCantidad === "" || isNaN(this.totalCantidad)) {
       this.totalCantidad = "";
     }
     this.$refs.codigoRef?.focus();
     this.resumeMainKeyboardEvents();
   });
 },

 setConsumidorFinal() {
   this.clienteSeleccionado = null;
   this.descuentoClientePct = 0;
   this.descuentoGeneralAplicado = 0;
   this.recalcularTodosLosProductos();
 },

 handleModalFocus(isFocused) {
   this.isModalFocused = isFocused;
 },

 handleRowDoubleClick(item) {
   if (this.selectedItem === item) {
     this.selectedItem = null;
   } else {
     this.selectedItem = item;
   }
 },

 eliminarItem() {
   if (this.productosLista.length === 0) {
     notis("info", "No hay datos en la tabla.");
     return;
   } else if (!this.selectedItem) {
     notis("info", "Seleccione un item para eliminar");
     return;
   }
   this.isEliminarModalVisible = true;
 },

 async limpiarPantalla() {
   if (this.productosLista.length === 0) {
     notis("info", "No hay datos en la tabla.");
     return;
   }
   this.isLimpiarPantallaModalVisible = true;
 },

 async handleLimpiarPantalla(data) {
   this.isModalLoading = true;
   try {
     for (const producto of this.productosLista) {
       const eliminando = await eliminarProductoVenta(
         producto.id_producto,
         data.clave,
         this.id_usuario
       );

       if (!eliminando) {
         throw "Ocurrió un error al limpiar la pantalla";
       }
     }

     this.productosLista = [];
     this.selectedItem = null;
     this.venta = [];
     this.factura = [];
     this.clienteSeleccionado = null;
     this.addQuery = "";
     this.totalCantidad = "";
     this.descuentoGeneralAplicado = 0;
     this.descuentoClientePct = 0;
     this.ncsAplicadas = [];
     this.cotizacionEnCurso = null;

     notis("success", "Pantalla limpiada correctamente");
   } catch (error) {
     const msg = error?.response?.data?.error || error?.message || "Error al limpiar pantalla.";
     notificaciones("error", msg);
   } finally {
     this.isModalLoading = false;
   }
 },

 closeLimpiarPantallaModal() {
   this.isLimpiarPantallaModalVisible = false;
 },

 async handleItemDelete(data) {
   this.isModalLoading = true;
   this.loadingMessage = "Eliminando item...";
   try {
     const index = this.productosLista.findIndex((p) => p === data.item);
     if (index !== -1) {
       const eliminando = await eliminarProductoVenta(
         this.productosLista[index].id_producto,
         data.clave,
         this.id_usuario
       );
       if (!eliminando) {
         throw "Ocurrió un error al eliminar Item";
       }
       this.productosLista.splice(index, 1);
       this.selectedItem = null;
       
       // Recalcular descuento general si queda algún producto
       if (this.productosLista.length > 0 && this.descuentoGeneralAplicado > 0) {
         this.recalcularDescuentoGeneral();
       } else if (this.productosLista.length === 0) {
         this.descuentoGeneralAplicado = 0;
       }
       
       const toast = useToast();
       toast.success("Item eliminado correctamente");
     }
   } catch (error) {
     const msg = error?.response?.data?.error || error?.message || "Error al eliminar item.";
     notificaciones("error", msg);
   } finally {
     this.isModalLoading = false;
   }
 },

 // NUEVO MÉTODO para recalcular descuento general
 recalcularDescuentoGeneral() {
   if (this.descuentoGeneralAplicado > 0 && this.productosLista.length > 0) {
     const totalSinDescuento = this.productosLista.reduce((total, p) => {
       return total + (p.precio_final + (p.descuento_general || 0));
     }, 0);
     
     const factorDescuento = this.descuentoGeneralAplicado / totalSinDescuento;
     
     this.productosLista.forEach(producto => {
       const precioSinDescuentoGeneral = producto.precio_final + (producto.descuento_general || 0);
       const descuentoProducto = precioSinDescuentoGeneral * factorDescuento;
       producto.descuento_general = descuentoProducto;
     });
   }
 },

 closeEliminarModal() {
   this.isEliminarModalVisible = false;
 },

 async logout() {
   // Si hay sesión soporte activa, dejar que App.vue muestre el modal de cierre
   if (sessionStorage.getItem('soporte_session')) {
     this.showConfirmModal = false;
     window.dispatchEvent(new CustomEvent('soporte-logout-request'));
     return;
   }
   this.isModalLoading = true;
   try {
     await axios.post(
       "/api/token/logout",
       {},
       {
         headers: {
           Authorization: `Bearer ${localStorage.getItem("auth")}`,
         },
       }
     );
   } catch (error) {
     console.error("Error al cerrar sesión", error);
   } finally {
     const darkPref = localStorage.getItem('isDarkMode');
     localStorage.clear();
     if (darkPref !== null) localStorage.setItem('isDarkMode', darkPref);
     this.$router.push("/login");
     this.isModalLoading = false;
   }
 },

 handleClientSelected(client) {
   this.clienteSeleccionado = client;
   this.closeModal();

   if (client.es_tercera_edad) {
     notis("success", `Cliente de tercera edad seleccionado. Descuento del 20% aplicado.`);
   }

   // Auto-descuento habitual del cliente
   this.descuentoClientePct = Number(client.descuento_habitual) || 0;
   if (this.descuentoClientePct > 0) {
     if (this.productosLista.length > 0) {
       this.aplicarDescuentoCliente();
     }
     const badge = client.tipo_cliente || 'Normal';
     notis("success", `Cliente ${badge} — descuento del ${this.descuentoClientePct}% aplicado automáticamente`);
   }
 },

 aplicarDescuentoCliente() {
   if (!this.descuentoClientePct || !this.productosLista.length) return;
   const totalSinImpuesto = this.productosLista.reduce((t, p) => {
     const base = (p.precio_mayorista > 0 && p.cantidad_activar_mayorista > 0 && p.cantidad >= p.cantidad_activar_mayorista)
       ? p.cantidad * p.precio_mayorista
       : p.cantidad * p.precio_unitario;
     return t + base;
   }, 0);
   const descuentoCalc = totalSinImpuesto * (this.descuentoClientePct / 100);
   this.handleDescuentoGeneral({ descuentoCalculado: descuentoCalc });
 },

 async openModal() {
   this.isModalLoading = true;
   this.loadingMessage = "Cargando clientes...";
   try {
     this.clientes = await getClientesbyEmpresa(this.id_usuario);
     this.isModalVisible = true;
   } catch (error) {
     notificaciones("error", error.message);
   } finally {
     this.isModalLoading = false;
   }
 },

 closeModal() {
   this.isModalVisible = false;
   this.$nextTick(() => {
     this.$refs.codigoRef?.focus();
   });
 },

 async nuevoCliente() {
   this.isModalLoading = true;
   this.loadingMessage = "Cargando clientes...";
   try {
     this.clientes = await getClientesbyEmpresa(this.id_usuario);
     this.isModalVisible = true;
     this.$nextTick(() => {
       this.$refs.clienteModal.abrirFormularioDirectamente();
     });
   } catch (error) {
     notificaciones("error", error.message);
   } finally {
     this.isModalLoading = false;
   }
 },

async realizarPago(datosPago) {
  let pagando = false;
  if (this.productosLista.length === 0) {
    const toast = useToast();
    toast.warning("No hay productos en la tabla de ventas.");
    return;
  }

  try {
    const idsNC = this.ncsAplicadas.map(nc => nc.id_devolucion);
    if (datosPago.metodoPago === "Efectivo") {
      pagando = await pagar(
        datosPago.montoEfectivo,
        this.venta.id_venta,
        datosPago.notas,
        this.id_usuario,
        idsNC
      );
    } else if (datosPago.metodoPago === "Transferencia") {
      pagando = await pagarTranferir(
        datosPago.montoTransferencia,
        this.venta.id_venta,
        datosPago.numeroTransferencia,
        datosPago.notas,
        this.id_usuario,
        idsNC
      );
    } else if (datosPago.metodoPago === "Mixto") {
      pagando = await pagarMixto(
        datosPago.montoEfectivo,
        datosPago.montoTransferencia,
        datosPago.numeroTransferencia,
        this.venta.id_venta,
        datosPago.notas,
        this.id_usuario,
        idsNC
      );
    } else if (datosPago.metodoPago === "Credito") {
      pagando = await registrarVentaCredito(
        this.venta.id_venta,
        datosPago.clienteSeleccionado.id_cliente,
        datosPago.notas,
        this.id_usuario,
        idsNC,
        datosPago.montoAdelanto || 0
      );

      // NUEVO: Actualizar el cliente seleccionado en el componente padre
      if (pagando) {
        this.clienteSeleccionado = datosPago.clienteSeleccionado;
      }
    }

    if (!pagando) {
      throw "No se realizo el pago";
    }

    if (this.cotizacionEnCurso) {
      await actualizarEstadoCotizacion(this.cotizacionEnCurso, 'Facturada');
      this.cotizacionEnCurso = null;
    }

    this.facturaActual =
      this.venta?.facturas?.[0]?.factura_SAR?.[0]?.numero_factura_SAR ||
      pagando.numero_factura ||
      "";

    this.isPagoModalVisible = false;
    this.isFacturaModalVisible = true;
    this.isPaymentAnimationVisible = true;

  } catch (error) {
    notificaciones("error", error.message);
  }
},

 handlePaymentComplete() {
   this.isPaymentAnimationVisible = false;
   this.limpiarPagado();
   this.facturaActual = "";
 },

async openPagoModal() {
 const toast = useToast();
 if (this.productosLista.length === 0) {
   toast.warning("No hay productos en la tabla de ventas.");
   return;
 }

 // Bloquear si se está verificando stock de un producto recién agregado
 if (this.cargandoProducto) {
   toast.warning("Espera, verificando stock del producto...");
   return;
 }

 const totalNumero = this.productosLista.reduce(
   (total, p) => total + p.precio_final,
   0
 );

 if (totalNumero <= 0) {
   const confirmar = window.confirm(
     '⚠️ El total de la venta es L. 0.00 (descuento del 100%).\n¿Confirma que esta venta es correcta?'
   );
   if (!confirmar) return;
 }

 if (!this.clienteSeleccionado && totalNumero > 10000) {
   toast.warning("Agregue un cliente para compras mayores a L. 10,0000");
   return;
 }
 
 this.isModalLoading = true;
 this.loadingMessage = "Procesando venta...";

 try {
   
   // Verificar que cada producto tenga los descuentos calculados
   
   if (this.venta.length === 0) {
     this.venta = await postVenta(
       this.productosLista,
       this.clienteSeleccionado ? this.clienteSeleccionado.id_cliente : 0,
       this.id_usuario
     );
   } else if (this.venta.factura.total !== this.calcularTotal) {
     const id_venta = this.venta.id_venta;
     const id_factura = this.venta.factura.id_factura;

     const promesas = [
       eliminarVenta(id_venta, id_factura),
       postVenta(
         this.productosLista,
         this.clienteSeleccionado
           ? this.clienteSeleccionado.id_cliente
           : 0,
         this.id_usuario
       ),
     ];

     const resultados = await Promise.all(promesas);
     const { resultado: resultadoEliVenta, message: messageElimVenta } =
       resultados[0];

     if (!resultadoEliVenta) {
       console.error("Ocurrio un error de servidor", messageElimVenta);
     }

     this.venta = resultados[1];
   }

   this.factura = this.venta.factura;
   
   this.isPagoModalVisible = true;

   this.$nextTick(() => {
     const pagoModalElement = document.querySelector(".modal-content");
     if (pagoModalElement) {
       pagoModalElement.focus();
     }
   });
 } catch (error) {
   console.error('Error completo en openPagoModal:', error);
   toast.error("Ocurrio un error al registrar venta.");
 } finally {
   this.isModalLoading = false;
 }
},

 closePagoModal() {
   this.isPagoModalVisible = false;
   this.$nextTick(() => {
     this.$refs.codigoRef?.focus();
   });
 },

 pauseMainKeyboardEvents() {
   window.removeEventListener("keydown", this.handleKeyPress);
 },

 resumeMainKeyboardEvents() {
   if (!this.isAnyModalOpen) {
     window.addEventListener("keydown", this.handleKeyPress);
   }
 },

 handleKeyPress(event) {
   if (!this.cajaAbierta && event.altKey && event.key === "s") {
     event.preventDefault();
     this.salir();
     return;
   }

   if (!this.cajaAbierta) {
     return;
   }

   // No interceptar si el foco está en un campo de texto
   const activeTag = document.activeElement?.tagName;
   if (activeTag === 'TEXTAREA' || activeTag === 'INPUT' || document.activeElement?.isContentEditable) {
     return;
   }

   if (this.isAnyModalOpen || this.isModalFocused) {
     return;
   }

   const key = event.key;

   if (
     key === "F3" ||
     key === "F12" ||
     key === "F4" ||
     key === "F5" ||
     key === "F6" ||
     key === "F8" ||
     key === "F9" ||
     key === "F10" ||
     key === "F11"
   ) {
     event.preventDefault();
   }

   if (!isNaN(key) || key === ".") {
     event.preventDefault();
     this.agregarNumero(key);
   } else if (key === "Backspace") {
     event.preventDefault();
     this.borrarUltimo();
   } else if (key === "Enter") {
     event.preventDefault();
     this.procesarEnter();
   } else if (event.altKey && key === "s") {
     event.preventDefault();
     this.salir();
   } else if (key === "F2") {
     event.preventDefault();
     this.buscarProducto();
   } else if (key === "F3") {
     event.preventDefault();
     this.openModal();
   } else if (key === "F4") {
     event.preventDefault();
     this.eliminarItem();
   } else if (key === "F5") {
     event.preventDefault();
     this.limpiarPantalla();
   } else if (key === "F6") {
     event.preventDefault();
     this.guardarVenta();
   } else if (key === "F7") {
     event.preventDefault();
     this.recVenta();
   } else if (key === "F8" && this.puedeDescuentoProducto) {
     event.preventDefault();
     this.abrirDescuentoProducto();
   } else if (key === "F9" && this.puedeDescuentoGeneral) {
     event.preventDefault();
     this.abrirDescuentoGeneral();
   } else if (key === "F12") {
     event.preventDefault();
     this.openPagoModal();
   }
 },

 agregarNumero(num) {
   this.addQuery += num.toString();
 },

 borrarUltimo() {
   if (this.addQuery.length > 0) {
     this.addQuery = this.addQuery.slice(0, -1);
   }
 },

 limpiar() {
   this.addQuery = "";
   this.totalCantidad = "";
   this.$refs.codigoRef?.focus();
 },

limpiarPagado() {
  this.addQuery = "";
  this.totalCantidad = "";
  this.productosLista = [];
  this.venta = [];
  this.factura = [];
  // MODIFICADO: No limpiar clienteSeleccionado para conservar el cliente en pantalla
  // this.clienteSeleccionado = null;
  this.facturaActual = "";
  this.descuentoGeneralAplicado = 0;
  this.ncsAplicadas = [];
},

 procesarEnter() {
   if (!this.cajaAbierta) return;
   this.agregarProducto();
 },

 // MÉTODO MODIFICADO: agregarProducto con cálculo correcto de impuestos
 async agregarProducto() {
   if (!this.cajaAbierta) return;

   let nuevaCantidad = this.totalCantidad;

   const codigoValidar = this.addQuery;
   if (!codigoValidar) {
     const toast = useToast();
     toast.warning("Ingresa un código");
     return;
   }

   nuevaCantidad = Math.floor(Number(nuevaCantidad));
   if (!nuevaCantidad || nuevaCantidad === 0) {
     nuevaCantidad = 1;
   }
   if (nuevaCantidad < 1) {
     const toast = useToast();
     toast.warning("La cantidad debe ser mayor a 0");
     return;
   }
   try {
    this.limpiar();
    const newProduct = this.productos.find(
      (p) => p.codigo_producto === codigoValidar
    );
    if (!newProduct) {
      const toast = useToast();
      toast.warning("No existe el producto");
      return;
    }

    const existingProduct = this.productosLista.find(
      (p) => p.codigo_producto === codigoValidar
    );

    if (existingProduct) {
      existingProduct.cantidad += nuevaCantidad;
    } else {

      const productoParaAgregar = {
        ...newProduct,
        cantidad: nuevaCantidad,
        precio_mayorista: newProduct.precio_mayorista || 0,
        cantidad_activar_mayorista: newProduct.cantidad_activar_mayorista || 0,
        precio_unitario: newProduct.precio_unitario || 0,
        descuento_manual: 0, // Inicializar descuento manual
        descuento_general: 0, // Inicializar descuento general
      };


      this.productosLista.push(productoParaAgregar);
    }

    // Recalcular descuento general si existe
    if (this.descuentoGeneralAplicado > 0) {
      this.recalcularDescuentoGeneral();
    }

    if (!this.recuperandoVenta) {
      this.cargandoProducto = true;
      try {
        const result = await agregarProductoCodigo(
          nuevaCantidad,
          codigoValidar,
          this.id_usuario
        );
        if (result.error) {
          const index = this.productosLista.findIndex(
            (i) => i.codigo_producto === codigoValidar
          );
          this.productosLista[index].cantidad =
            this.productosLista[index].cantidad - nuevaCantidad;
          if (this.productosLista[index].cantidad < 1) {
            this.productosLista.splice(index, 1);
          }
          result.message = "No hay stock disponible en el inventario.";
          throw result;
        }
      } finally {
        this.cargandoProducto = false;
      }
    }
  } catch (error) {
    notificaciones("error", error.message);
  }
},

async guardarVenta() {
  if (this.productosLista.length === 0) {
    const toast = useToast();
    toast.warning("No hay productos para guardar");
    return;
  }

  if (!this.clienteSeleccionado) {
    this.isGuardarVentaModalVisible = true;
  } else {
    this.guardarVentainBD(this.clienteSeleccionado.nombre_completo);
  }
},

async guardarVentainBD(nombre_completo) {
  this.isModalLoading = true;
  try {
    const response = await guardarVenta(nombre_completo, this.id_usuario);
    if (response) {
      this.limpiarPagado();
      notificaciones("venta-guardada");
    } else {
      throw "Ocurrio un error al guardar venta. Intente mas tarde";
    }
  } catch (error) {
    notificaciones("error", error.message);
  } finally {
    this.isModalLoading = false;
  }
},

async abrirModalCotizaciones() {
  this.isModalLoading = true;
  try {
    const todas = await getCotizaciones(this.id_usuario, 'Aceptada');
    this.cotizacionesPendientes = Array.isArray(todas) ? todas : [];
  } catch (e) {
    notificaciones('error', 'Error al cargar cotizaciones');
  } finally {
    this.isModalLoading = false;
    this.isCotizacionesModalVisible = true;
    this.$nextTick(() => this.$refs.cotModal?.focus());
  }
},

async facturarDesdeCotizacion(c) {
  this.facturandoCot = c.id_cotizacion;
  this.isCotizacionesModalVisible = false;
  this.isModalLoading = true;
  try {
    const detalle = await getDetalleCotizacion(c.id_cotizacion);
    const detalles = detalle.detalle_cotizaciones || [];

    const items = detalles.map(i => {
      const prod = this.productos.find(p => p.id_producto == i.id_producto);
      return prod ? { codigo_producto: prod.codigo_producto, cantidad: i.cantidad } : null;
    }).filter(Boolean);

    if (!items.length) {
      notificaciones('error', 'Esta cotización no tiene productos con código válido');
      return;
    }

    if (detalle.id_cliente) {
      if (!this.clientes.length) {
        this.clientes = await getClientesbyEmpresa(this.id_usuario);
      }
      const cliente = this.clientes.find(cl => cl.id_cliente == detalle.id_cliente);
      if (cliente) this.clienteSeleccionado = cliente;
    }

    for (const item of items) {
      this.addQuery = item.codigo_producto;
      this.totalCantidad = item.cantidad;
      await this.agregarProducto();
    }

    this.cotizacionEnCurso = c.id_cotizacion;
    notis('success', `Cotización ${c.numero_cotizacion} cargada. Registra el pago para confirmarla.`);
  } catch (e) {
    notificaciones('error', 'Error al cargar cotización: ' + e.message);
  } finally {
    this.facturandoCot = null;
    this.isModalLoading = false;
  }
},

async handleVentaSelected(data) {
  this.isModalLoading = true;
  try {
    const res = await getRecProductoVenta(data.id_compra_guardada);
    const productosRec = Array.isArray(res) ? res : (res?.productos || []);

    if (!productosRec.length) {
      notificaciones("error", "La venta guardada no tiene productos.");
      return;
    }

    this.recuperandoVenta = true;
    for (const producto of productosRec) {
      this.addQuery = producto.codigo_producto;
      this.totalCantidad = producto.cantidad;
      await this.agregarProducto();
    }
    this.recuperandoVenta = false;
  } catch (error) {
    notificaciones("error", "Error al recuperar venta. Intente de nuevo mas tarde.");
  } finally {
    this.isModalLoading = false;
  }
},

async RecventaPendiente(productosRec) {
  this.isModalLoading = true;
  try {
    this.recuperandoVenta = true;

    for (const producto of productosRec) {
      this.addQuery = producto.codigo_producto;
      this.totalCantidad = producto.cantidad;
      await this.agregarProducto();
    }

    this.recuperandoVenta = false;
  } catch (error) {
    notificaciones(
      "error",
      "Error al recuperar venta. Intente de nuevo mas tarde."
    );
  } finally {
    this.isModalLoading = false;
  }
},

async handleSaveVenta(data) {
  this.isGuardarVentaModalVisible = false;
  await this.guardarVentainBD(data);
},

async recVenta() {
  this.isModalLoading = true;
  try {
    const ventasGuardadas = await getVentasGuardadas(this.id_usuario);
    this.ventasGuardadas = ventasGuardadas;
    this.isRecuperarVentaModalVisible = true;
  } catch (error) {
    notificaciones("error", error);
  } finally {
    this.isModalLoading = false;
  }
},

async recVenta2() {
  this.isModalLoading = true;
  try {
    await getVentasGuardadas(this.id_usuario);
  } catch (error) {
    notificaciones("error", error);
  } finally {
    this.isModalLoading = false;
  }
},

pushEsc(event) {
  if (event.key === "Esc" || event.key === "Escape") {
    if (this.isEditing) {
      this.isEditing = false;
      this.reiniciarInputs();
      return;
    }
    this.cancelarVenta();
  }
},

handleEscGlobal(event) {
  if (event.key !== "Escape") return;
  if (this.modalNC.visible)                 { this.cerrarModalNC(); return; }
  if (this.showCuentaModal)                 { this.showCuentaModal = false; return; }
  if (this.profileDropdownOpen)             { this.profileDropdownOpen = false; return; }
  if (this.showHelpModal)                   { this.showHelpModal = false; return; }
  if (this.isPagoModalVisible)              { this.closePagoModal(); return; }
  if (this.isFacturaModalVisible)           { this.closeFacturaModal(); return; }
  if (this.isCotizacionesModalVisible)      { this.isCotizacionesModalVisible = false; return; }
  if (this.isModalVisible)                  { this.closeModal(); return; }
  if (this.isBuscarProductoModalVisible)    { this.closeBuscarProductoModal(); return; }
  if (this.isCerrarCajaModalVisible)        { this.isCerrarCajaModalVisible = false; return; }
  if (this.isDescuentoProductoModalVisible) { this.isDescuentoProductoModalVisible = false; return; }
  if (this.isDescuentoGeneralModalVisible)  { this.isDescuentoGeneralModalVisible = false; return; }
  if (this.isEliminarModalVisible)          { this.closeEliminarModal(); return; }
  if (this.isLimpiarPantallaModalVisible)   { this.closeLimpiarPantallaModal(); return; }
  if (this.isGuardarVentaModalVisible)      { this.isGuardarVentaModalVisible = false; return; }
  if (this.isRecuperarVentaModalVisible)    { this.isRecuperarVentaModalVisible = false; return; }
  if (this.showConfirmModal)                { this.showConfirmModal = false; return; }
},

pushDelete(event) {
  const target = event.target;
  const isInputField =
    target.tagName === "INPUT" ||
    target.tagName === "TEXTAREA" ||
    target.isContentEditable;

  if (!isInputField && event.key === "Backspace") {
    this.deleteUltimo();
  }
},

handleInputChange(event) {
  this.addQuery = event.target.value;
},

changeFavicon(iconPath) {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "icon";
  link.href = iconPath;
  document.getElementsByTagName("head")[0].appendChild(link);
},

toggleEditingMode() {
  this.isEditing = !this.isEditing;
},

showInfo() {
},
},

// MÉTODO MODIFICADO: mounted con cálculo correcto de impuestos
async mounted() {
this.isModalLoading = true;
let ventaRecuperada;
window.addEventListener("keydown", this.handleKeyPress);
window.addEventListener("keydown", this.handleEscGlobal);
document.addEventListener("mousedown", this.onUsrClickOutside);
// Sincronizar clase dark en <html> para que los modales teleportados la hereden
document.documentElement.classList.toggle('dark', this.isDark);
setPageTitle("Crear Ventas");
this.fetchPerfil();

try {
  this.id_usuario = await solicitudes.solicitarUsuarioToken();
  this.usaSAR = await sucursalSar(this.id_usuario);
  this.info = await getInfoBasic(this.id_usuario);
  
  // MODIFICACIÓN: Cargar productos sin calcular impuestos aquí (se calculan en tiempo real)
  const productosRaw = await getProductos(this.id_usuario);
  this.productos = productosRaw;
  
  
  this.cajaAbierta = await cajaUsuario(this.id_usuario);
  this.estadoCajaValidado = true;

  ventaRecuperada = await getVentaPendiente(this.id_usuario);
  if (ventaRecuperada?.resultado) {
    await this.RecventaPendiente(ventaRecuperada.productos);
  }
} catch (error) {
  notificaciones("error", error.message);
  this.estadoCajaValidado = true;
} finally {
  this.isModalLoading = false;
}
const _s = getSocket();
if (_s) {
  this._wsRefresh = async () => {
    if (this.id_usuario && this.cajaAbierta) {
      const raw = await getProductos(this.id_usuario);
      this.productos = raw.map(p => ({
        ...p,
        precioImpuesto: this.calcularImpuestoPorId(p.precio_unitario, p.impuesto),
        precioImpuestoMayorista: p.precio_mayorista ? this.calcularImpuestoPorId(p.precio_mayorista, p.impuesto) : 0,
      }));
    }
  };
  _s.on('productos:refresh', this._wsRefresh);
  _s.on('inventario:refresh', this._wsRefresh);
  // Notificación cuando el admin anula una venta propia
  this._wsAnulacion = (payload) => {
    if (Number(payload.id_cajero_original) === Number(this.id_usuario)) {
      this.notifAnulacion = payload;
    }
  };
  _s.on('venta:anulada', this._wsAnulacion);
}
},

beforeUnmount() {
window.removeEventListener("keydown", this.handleKeyPress);
window.removeEventListener("keydown", this.handleEscGlobal);
document.removeEventListener("mousedown", this.onUsrClickOutside);
const _s = getSocket();
if (_s && this._wsRefresh) {
  _s.off('productos:refresh', this._wsRefresh);
  _s.off('inventario:refresh', this._wsRefresh);
  if (this._wsAnulacion) _s.off('venta:anulada', this._wsAnulacion);
}
},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

* {
font-family: "Montserrat", sans-serif;
box-sizing: border-box;
margin: 0;
padding: 0;
}

/* Layout Principal */
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
padding: clamp(10px, 2vw, 20px);
z-index: 1;
min-height: 100vh;
}

/* Estados de Facturación */
.facturando {
color: #0c9200;
font-weight: bold;
}

.no-facturando {
color: #c90101;
font-weight: bold;
}

.main-container {
display: flex;
flex-direction: column;
align-items: center;
width: 100%;
z-index: 1;
margin: 0;
padding: 0 clamp(10px, 2vw, 20px);
}

/* Header */
.header-container {
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: flex-start;
padding: clamp(5px, 1.5vw, 10px);
border-bottom: 1px solid #ccc;
width: 100%;
max-width: 1200px;
margin: 0 auto;
}

.input-button-container {
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
gap: 5px;
}

.inputs-container,
.buttons-header {
justify-content: center;
display: flex;
gap: 5px;
width: 100%;
}

.cliente-input,
.rtn-input {
padding: 6px 8px;
border: 1px solid #ccc;
border-radius: 4px;
background-color: #f5f5f5;
height: 30px;
font-size: clamp(12px, 1.5vw, 14px);
width: 50%;
}

.rtn-input {
color: #666;
}

.cliente-tipo-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
  align-self: center;
}

.badge-tipo-frecuente { background: #dbeafe; color: #1d4ed8; }
.badge-tipo-vip       { background: #fef3c7; color: #92400e; }

.dark .badge-tipo-frecuente { background: rgba(29,78,216,0.25); color: #93c5fd; }
.dark .badge-tipo-vip       { background: rgba(146,64,14,0.25);  color: #fcd34d; }

.search-button {
height: 30px;
padding: 0 8px;
background-color: #f0f0f0;
border: 1px solid #ccc;
border-radius: 4px;
font-size: clamp(12px, 1.5vw, 14px);
width: 50%;
}

.campo {
height: 40px;
background-color: #f0f0f0;
border: 1px solid #ccc;
border-radius: 4px;
cursor: pointer;
display: flex;
align-items: center;
justify-content: center;
font-size: clamp(16px, 2vw, 20px);
margin-bottom: 15px;
text-align: center;
width: 100%;
}

.search-button:hover {
background-color: #e0e0e0;
}

/* Indicador de tercera edad */
.tercera-edad-banner {
background-color: #e8f5e8;
border: 2px solid #4caf50;
border-radius: 4px;
padding: 8px 12px;
margin: 5px 0;
text-align: center;
font-weight: bold;
color: #2e7d32;
animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
from { opacity: 0; transform: translateY(-10px); }
to { opacity: 1; transform: translateY(0); }
}

.dark .tercera-edad-banner {
background-color: #1a2f1a;
border-color: #c09d62;
color: #c09d62;
}

.tercera-edad-product {
background-color: #f8fff8 !important;
}

.tercera-edad-product:hover {
background-color: #e8f5e8 !important;
}

.dark .tercera-edad-product {
background-color: #1a2f1a !important;
}

.dark .tercera-edad-product:hover {
background-color: #2a3f2a !important;
}

.descuento-resumen {
background-color: #e8f5e8;
border: 1px solid #4caf50;
border-radius: 4px;
padding: 5px 10px;
color: #2e7d32;
font-weight: bold;
font-size: 14px;
}

.dark .descuento-resumen {
background-color: #1a2f1a;
border-color: #c09d62;
color: #c09d62;
}

/* Información Section */
.tipo-cliente,
.informacion-1,
.informacion-2 {
flex: 1;
display: flex;
flex-direction: column;
align-items: center;
padding: 0 15px;
max-width: 400px;
}

/* Column Container y Tabla */
.column-container {
display: flex;
flex-direction: row;
width: 100%;
height: calc(100vh - 250px);
margin-bottom: 10px;
z-index: 1;
flex-wrap: wrap;
gap: 10px;
}

.table-container {
width: 100%;
flex: 1 1 300px;
display: flex;
flex-direction: column;
position: relative;
overflow-y: auto;
}

.table-wrapper {
flex-grow: 1;
border: 1px solid #ccc;
display: flex;
flex-direction: column;
height: 100%;
}

.table {
width: 100%;
border-collapse: collapse;
background: white;
}

.table thead {
position: sticky;
top: 0;
z-index: 2;
background: white;
display: table;
width: 100%;
table-layout: fixed;
}

.table tbody {
display: block;
overflow-y: auto;
width: 100%;
height: clamp(200px, 50vh, 340px);
}

.table tbody tr {
display: table;
width: 100%;
table-layout: fixed;
}

/* Estilos de la tabla con nueva columna */
th {
background-color: #f0f0f0;
border-bottom: 1px solid #ccc;
padding: clamp(5px, 1.5vw, 10px);
text-align: left;
font-weight: 600;
font-size: clamp(12px, 1.5vw, 14px);
}

td {
padding: clamp(5px, 1.5vw, 10px);
text-align: left;
border-bottom: 1px solid #eee;
font-size: clamp(12px, 1.5vw, 14px);
}

.col-tipo-desc {
width: 80px;
font-size: 11px;
text-align: center;
}

.right-section {
width: clamp(250px, 20%, 300px);
display: flex;
flex-direction: column;
gap: 15px;
border-left: 1px solid #ccc;
padding: 10px;
}

.abrir-caja-button {
width: 100%;
padding: 12px;
background-color: #198754;
color: #fff;
border: none;
border-radius: 4px;
font-size: 16px;
font-weight: 600;
cursor: pointer;
transition: background-color 0.2s;
margin-top: 35%;
}

.abrir-caja-button:hover {
background-color: #146c43;
}

.dark .abrir-caja-button {
background-color: #198754;
color: #fff;
}

.dark .abrir-caja-button:hover {
background-color: #146c43;
}

/* Teclado Numérico */
.numeric-keypad {
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
z-index: 1;
}

.keypad {
display: grid;
grid-template-columns: repeat(3, 1fr);
gap: clamp(5px, 1vw, 10px);
width: 100%;
}

/* Botones */
button {
width: 100%;
height: clamp(35px, 5vw, 40px);
font-size: clamp(14px, 2vw, 18px);
border: none;
border-radius: 5px;
background-color: #f0f0f0;
cursor: pointer;
}

/* Total Container */
.total-container {
display: flex;
justify-content: flex-end;
align-items: center;
gap: clamp(10px, 2vw, 20px);
padding: clamp(5px, 1.5vw, 10px);
background-color: #f5f5f5;
border: 1px solid #ccc;
border-top: none;
flex-wrap: wrap;
}

.cantidad-input,
.total-input {
display: flex;
align-items: center;
gap: clamp(5px, 1vw, 10px);
}

.cantidad-input input {
width: 100px;
height: 30px;
padding: 5px;
border: 1px solid #ccc;
border-radius: 4px;
}

/* Footer */
.footer-container {
position: fixed;
bottom: 0;
left: 0;
width: 100%;
display: flex;
flex-wrap: wrap;
justify-content: space-around;
padding: clamp(3px, 1vw, 5px);
background-color: #f0f0f0;
border-top: 1px solid #ccc;
z-index: 2;
gap: 5px;
}

.footer-container button {
width: clamp(50px, 10vw, 70px);
height: clamp(50px, 10vw, 70px);
border-radius: 0%;
font-size: clamp(10px, 1.5vw, 12px);
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background-color: #d1d1d1;
transition: background-color 0.2s ease;
white-space: pre-line;
line-height: 1.2;
text-align: center;
}

.footer-container button:hover {
background-color: #b4b4b4;
}

.dark .footer-container button {
background-color: #2a2a2a;
color: #c09d62;
border: 1px solid #3a3a3a;
}

.dark .footer-container button:hover {
background-color: #3b3b3b;
border-color: #555;
}

.subTotal {
font-size: clamp(24px, 5vw, 36px);
font-weight: bold;
margin: 0;
}

.selected {
background-color: #63b4ff !important;
}

.table tbody tr.selected:hover {
background-color: #d1e8ff !important;
}

/* Scrollbar personalizado */
.table-container::-webkit-scrollbar {
width: 8px;
height: 8px;
}

.table-container::-webkit-scrollbar-track {
background: #f1f1f1;
border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
background: #888;
border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
background: #555;
}

/* =======================================================
 Modo Oscuro
======================================================= */
.dark {
background-color: #141414;
color: #e5e5e5;
}

.dark .wrapper,
.dark .main-container {
background-color: #141414;
}

.dark .header-container {
border-color: #2b2b2b;
}

.dark .cliente-input,
.dark .rtn-input,
.dark .campo {
background-color: #141414;
border-color: #2b2b2b;
color: #e5e5e5;
}

.dark .search-button {
background-color: #1a1a1a;
border-color: #2b2b2b;
color: #c09d62;
}

.dark .search-button:hover {
background-color: #202020;
color: #d4b07a;
}

.dark .table-wrapper {
border-color: #2b2b2b;
background-color: #141414;
}

.dark .table,
.dark .table thead {
background-color: #141414;
}

.dark th {
background-color: #1a1a1a;
border-color: #2b2b2b;
color: #c09d62;
}

.dark td {
border-color: #2b2b2b;
color: #e5e5e5;
}

.dark .table tbody tr:hover {
background-color: #202020;
}

.dark .selected {
background-color: #1d909b !important;
}

.dark .table tbody tr.selected:hover {
background-color: #204060 !important;
}

.dark .numeric-keypad {
border-color: #2b2b2b;
}

.dark .right-section {
border-left-color: #2b2b2b;
}

.dark button {
background-color: #1a1a1a;
border: 1px solid #2b2b2b;
color: #c09d62;
}

.dark button:hover:not(:disabled) {
background-color: #202020;
color: #d4b07a;
}

.dark button:disabled {
background-color: #0f0f0f;
border-color: #1f1f1f;
color: #404040;
}

.dark .total-container {
background-color: #141414;
border-color: #2b2b2b;
}

.dark .total-container label {
color: #c09d62;
}

.dark .subTotal {
color: #c09d62;
}

.dark .cantidad-input input {
background-color: #141414;
border-color: #2b2b2b;
color: #c09d62;
}

input:focus {
outline: none;
border-color: #c09d62;
box-shadow: 0 0 0 3px rgba(192, 157, 98, 0.2);
transition: all 0.3s ease;
}

.dark .footer-container {
background-color: #141414;
border-color: #2b2b2b;
}

.dark .facturando {
color: #c09d62;
}

.dark .no-facturando {
color: #ff4444;
}

.dark .table-container::-webkit-scrollbar-track {
background: #141414;
}

.dark .table-container::-webkit-scrollbar-thumb {
background: #2b2b2b;
}

.dark .table-container::-webkit-scrollbar-thumb:hover {
background: #363636;
}

.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover,
.dark input:-webkit-autofill:focus {
-webkit-text-fill-color: #e5e5e5;
-webkit-box-shadow: 0 0 0px 1000px #141414 inset;
}

.dark .abrir-caja-button {
background-color: #198754;
color: #fff;
}

.dark .abrir-caja-button:hover {
background-color: #146c43;
}

button:disabled {
background-color: #cccccc;
cursor: not-allowed;
opacity: 0.7;
}

/* Media Queries Grandes (Desktops/Laptops grandes) */
@media screen and (min-width: 1200px) {
.column-container {
  gap: 20px;
}

.right-section {
  width: 300px;
}
}

/* Media Queries Medianas (Tablets/Laptops pequeñas) */
@media screen and (max-width: 1024px) {
.usuario-config {
  width: 95%;
}

.contenedor-principal {
  flex-direction: column;
  align-items: center;
}

.contenedor-interno {
  width: 90%;
  padding: 0;
}

form {
  min-width: 100%;
}
}

/* Media Queries para Tablets */
@media screen and (max-width: 768px) {
.header-container {
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.tipo-cliente,
.informacion-1,
.informacion-2 {
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
}

.numeric-keypad {
  width: 100%;
  border-left: none;
  border-top: 1px solid #ccc;
}

.column-container {
  flex-direction: column;
  height: auto;
  min-height: 0;
}

.table-container {
  overflow-y: visible;
}

.right-section {
  width: 100%;
  border-left: none;
  border-top: 1px solid #ccc;
}

.total-container {
  justify-content: center;
}

.busqueda {
  width: 100%;
}

.table thead th,
.table tbody td {
  padding: 8px;
  font-size: 14px;
}

.col-tipo-desc {
  width: 60px;
  font-size: 10px;
}
}

/* Media Queries para Móviles */
@media screen and (max-width: 480px) {
.inputs-container {
  flex-direction: column;
}

.cliente-input,
.rtn-input {
  width: 100%;
}

.buttons-header {
  width: 100%;
  flex-direction: column;
}

.search-button {
  width: 100%;
}

.footer-container {
  gap: 8px;
}

.footer-container button {
  width: calc(50% - 8px);
  height: 60px;
  font-size: 11px;
  padding: 5px;
}

.table thead th,
.table tbody td {
  padding: 6px;
  font-size: 12px;
}

.subTotal {
  font-size: 24px;
}

.keypad button {
  height: 45px;
  font-size: 16px;
}

.col-tipo-desc {
  width: 50px;
  font-size: 9px;
}

.tercera-edad-banner {
  font-size: 12px;
  padding: 6px 8px;
}

.descuento-resumen {
  font-size: 12px;
  padding: 3px 6px;
}
}

/* Media Queries para Móviles Pequeños */
@media screen and (max-width: 320px) {
.footer-container button {
  width: 100%;
  height: 50px;
  font-size: 10px;
}

.table thead th,
.table tbody td {
  padding: 4px;
  font-size: 11px;
}

.keypad button {
  height: 40px;
  font-size: 14px;
}

.col-tipo-desc {
  width: 40px;
  font-size: 8px;
}
}

/* ── User Pill (fixed top-right) ── */
.usr-pill-wrap {
  position: fixed;
  top: 10px;
  right: 18px;
  z-index: 950;
}
.usr-pill {
  display: flex; align-items: center; gap: 10px;
  padding: 6px 10px 6px 6px;
  border-radius: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background .18s;
  white-space: nowrap;
}
.usr-pill:hover, .usr-pill.active {
  background: rgba(192,157,98,.1);
}
.usr-avatar {
  width: 36px; height: 36px; border-radius: 9px; flex-shrink: 0;
  background: linear-gradient(135deg, #c09d62 0%, #8c7040 100%);
  color: #111; font-size: 13px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
}
.usr-info { display: flex; flex-direction: column; align-items: flex-start; }
.usr-name { font-size: 13px; font-weight: 600; color: #c09d62; line-height: 1.25; }
.usr-role { font-size: 11px; color: #999; line-height: 1.2; }
.usr-caret {
  font-size: 10px; color: rgba(192,157,98,.6);
  transition: transform .2s;
}
.usr-caret.rotated { transform: rotate(180deg); }

/* ── User Dropdown ── */
.usr-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 230px;
  background: #fff;
  border: 1px solid rgba(0,0,0,.1);
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0,0,0,.18);
  overflow: hidden;
  z-index: 1100;
}
.usr-dd-header {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 14px 12px;
}
.usr-dd-avatar {
  width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
  background: linear-gradient(135deg, #c09d62 0%, #8c7040 100%);
  color: #111; font-size: 13px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
}
.usr-dd-name { display: block; font-size: 12px; font-weight: 700; color: #222; }
.usr-dd-role { font-size: 10px; color: #999; }
.usr-dd-divider { height: 1px; background: rgba(0,0,0,.08); margin: 0 10px; }
.usr-dd-item {
  display: flex; align-items: center; gap: 11px;
  width: 100%; padding: 11px 14px;
  background: transparent; border: none;
  text-decoration: none; cursor: pointer;
  transition: background .15s;
}
.usr-dd-item:hover { background: rgba(192,157,98,.09); }
.usr-dd-item.danger:hover { background: rgba(220,60,60,.07); }
.usr-dd-icon {
  width: 30px; height: 30px; border-radius: 8px; flex-shrink: 0;
  background: rgba(192,157,98,.1);
  border: 1px solid rgba(192,157,98,.18);
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; color: #c09d62;
}
.usr-dd-item.danger .usr-dd-icon { background: rgba(220,60,60,.08); border-color: rgba(220,60,60,.18); color: #e05555; }
.usr-dd-text { display: flex; flex-direction: column; text-align: left; }
.usr-dd-label { font-size: 12px; font-weight: 600; color: #333; }
.usr-dd-sub { font-size: 10px; color: #aaa; }
.usr-dd-item.danger .usr-dd-label { color: #e05555; }
.usr-dd-fade-enter-active, .usr-dd-fade-leave-active { transition: opacity .15s, transform .15s; }
.usr-dd-fade-enter-from, .usr-dd-fade-leave-to { opacity: 0; transform: translateY(-6px); }

/* dark pill */
.app-wrapper.dark .usr-pill { background: transparent; border: none; }
.app-wrapper.dark .usr-pill:hover, .app-wrapper.dark .usr-pill.active { background: rgba(192,157,98,.1); }
.app-wrapper.dark .usr-dropdown { background: #1a1a1a; border-color: rgba(192,157,98,.2); box-shadow: 0 12px 40px rgba(0,0,0,.55); }
.app-wrapper.dark .usr-dd-name { color: #c09d62; }
.app-wrapper.dark .usr-dd-role { color: rgba(214,208,200,.4); }
.app-wrapper.dark .usr-dd-divider { background: rgba(192,157,98,.15); }
.app-wrapper.dark .usr-dd-item:hover { background: rgba(192,157,98,.08); }
.app-wrapper.dark .usr-dd-label { color: #d6d0c8; }
.app-wrapper.dark .usr-dd-sub { color: rgba(214,208,200,.4); }

/* ── Modal Mi Cuenta ── */
.cuenta-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.45);
  display: flex; align-items: center; justify-content: center;
  z-index: 9995;
}
.cuenta-modal {
  position: relative;
  background: #fff;
  border-radius: 16px;
  width: 100%; max-width: 440px;
  padding: 28px 28px 20px;
  box-shadow: 0 20px 60px rgba(0,0,0,.22);
  font-family: 'Montserrat', sans-serif;
}
.cuenta-header {
  display: flex; align-items: center; gap: 14px;
  margin-bottom: 20px;
}
.cuenta-avatar-lg {
  width: 48px; height: 48px; border-radius: 12px; flex-shrink: 0;
  background: linear-gradient(135deg, #c09d62 0%, #8c7040 100%);
  color: #111; font-size: 18px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
}
.cuenta-title { font-size: 17px; font-weight: 700; color: #222; margin: 0; }
.cuenta-subtitle { font-size: 12px; color: #999; }
.cuenta-section-title {
  font-size: 11px; font-weight: 700; color: #c09d62;
  text-transform: uppercase; letter-spacing: .06em;
  margin-bottom: 10px;
}
.cuenta-opt { font-size: 10px; color: #aaa; text-transform: none; font-weight: 400; letter-spacing: 0; }
.cuenta-field { margin-bottom: 10px; }
.cuenta-field label { display: block; font-size: 11px; color: #777; margin-bottom: 4px; font-weight: 600; }
.cuenta-field input {
  width: 100%; padding: 9px 12px;
  border: 1px solid #ddd; border-radius: 8px;
  font-size: 13px; outline: none;
  transition: border-color .2s;
  background: #fafafa;
}
.cuenta-field input:focus { border-color: #c09d62; background: #fff; }
.cuenta-actions { display: flex; gap: 10px; justify-content: flex-end; margin-top: 20px; }
.btn-cuenta-cancel {
  padding: 9px 18px; border-radius: 8px;
  border: 1px solid #ddd; background: transparent;
  font-size: 13px; color: #666; cursor: pointer;
}
.btn-cuenta-cancel:hover { background: #f5f5f5; }
.btn-cuenta-save {
  padding: 9px 20px; border-radius: 8px;
  border: none; background: #198754; color: #fff;
  font-size: 13px; font-weight: 700; cursor: pointer;
  transition: background .2s;
}
.btn-cuenta-save:hover:not(:disabled) { background: #146c43; }
.btn-cuenta-save:disabled { opacity: .6; cursor: not-allowed; }

/* dark cuenta modal */
.app-wrapper.dark .cuenta-modal { background: #1e1e1e; border: 1px solid rgba(192,157,98,.2); }
.app-wrapper.dark .cuenta-title { color: #e0d8cc; }
.app-wrapper.dark .cuenta-subtitle { color: rgba(214,208,200,.4); }
.app-wrapper.dark .cuenta-field label { color: rgba(214,208,200,.55); }
.app-wrapper.dark .cuenta-field input { background: #2a2a2a; border-color: rgba(255,255,255,.1); color: #e0d8cc; }
.app-wrapper.dark .cuenta-field input:focus { border-color: #c09d62; background: #2f2f2f; }
.app-wrapper.dark .btn-cuenta-cancel { border-color: rgba(255,255,255,.1); color: #aaa; }
.app-wrapper.dark .btn-cuenta-cancel:hover { background: rgba(255,255,255,.05); }

/* ── Botón flotante dark/light mode ── */
.help-fab {
  position: fixed;
  bottom: 72px;
  right: 16px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #c09d62;
  color: #111;
  font-size: 20px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0,0,0,0.3);
  z-index: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: background .18s, transform .15s;
}
.help-fab:hover { background: #a8863f; transform: scale(1.08); }

/* ── Modal ayuda cajero ── */
.help-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  z-index: 9990;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.help-modal {
  position: relative;
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 560px;
  max-height: 88vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 48px rgba(0,0,0,0.4);
}
.app-wrapper.dark .help-modal { background: #1a1a1a; color: #d6d0c8; }

.help-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  flex-shrink: 0;
}
.app-wrapper.dark .help-header { border-color: rgba(255,255,255,0.08); }
.help-header i { font-size: 20px; color: #c09d62; }
.help-header h2 { margin: 0; font-size: 18px; font-weight: 700; color: #1a1a1a; }
.app-wrapper.dark .help-header h2 { color: #d6d0c8; }

.help-body {
  overflow-y: auto;
  padding: 16px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.help-section h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 700;
  color: #333;
}
.app-wrapper.dark .help-section h3 { color: #c09d62; }

.help-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #c09d62;
  color: #111;
  font-size: 12px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.help-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.help-table tr { border-bottom: 1px solid rgba(0,0,0,0.05); }
.app-wrapper.dark .help-table tr { border-color: rgba(255,255,255,0.06); }
.help-table td { padding: 5px 6px; vertical-align: top; }
.help-table td:last-child { color: #444; line-height: 1.35; }
.app-wrapper.dark .help-table td:last-child { color: #b0a89e; }

.key {
  background: #f0ebe3;
  color: #8c6e2f;
  border-radius: 6px;
  padding: 2px 7px !important;
  font-weight: 700;
  font-size: 12px;
  white-space: nowrap;
  width: 64px;
  text-align: center;
}
.app-wrapper.dark .key { background: rgba(192,157,98,.12); color: #c09d62; }
.key.warn  { background: #fff0e0; color: #c06000; }
.app-wrapper.dark .key.warn { background: rgba(192,96,0,.18); color: #e09040; }
.key.green { background: #e8f5e9; color: #2e7d32; }
.app-wrapper.dark .key.green { background: rgba(46,125,50,.2); color: #66bb6a; }

.help-tip  { font-size: 12px; color: #7a6a50; margin: 8px 0 0; }
.help-warn { font-size: 12px; color: #b84000; background: #fff3e0; border-radius: 8px; padding: 8px 10px; margin: 8px 0 0; }
.app-wrapper.dark .help-tip  { color: #a09080; }
.app-wrapper.dark .help-warn { background: rgba(184,64,0,.15); color: #e09040; }

.help-ol {
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
  color: #444;
  line-height: 1.6;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.app-wrapper.dark .help-ol { color: #b0a89e; }
.help-ol code {
  background: #f0ebe3;
  padding: 1px 5px;
  border-radius: 4px;
  font-family: monospace;
  color: #8c6e2f;
}
.app-wrapper.dark .help-ol code { background: rgba(192,157,98,.12); color: #c09d62; }

/* Modal cotizaciones pendientes */
.cot-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cot-modal {
  background: #fff;
  border-radius: 8px;
  width: min(700px, 95vw);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
}
.cot-header {
  padding: 14px 52px 14px 20px;
  background: #c09d62;
  color: #fff;
}
.cot-header h3 { margin: 0; font-size: 16px; white-space: nowrap; }
.cot-body {
  overflow-y: auto;
  padding: 16px;
}
.cot-empty { text-align: center; color: #666; padding: 30px 0; }
.cot-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.cot-table th { background: #f8f9fa; padding: 8px 10px; text-align: left; border-bottom: 2px solid #dee2e6; }
.cot-modal .modal-close-x { color: #fff !important; }
.cot-modal .modal-close-x:hover { background-color: rgba(0,0,0,0.15) !important; color: #fff !important; }
.cot-table td { padding: 8px 10px; border-bottom: 1px solid #dee2e6; }
.cot-table tr:hover td { background: #f5f5f5; }
.cot-btn-facturar {
  background: #198754;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 14px;
  cursor: pointer;
  font-size: 13px;
  transition: background .15s;
}
.cot-btn-facturar:hover:not(:disabled) { background: #146c43; }
.cot-btn-facturar:disabled { opacity: 0.6; cursor: not-allowed; }

/* ── Dark mode cotizaciones ── */
.app-wrapper.dark .cot-overlay { background: rgba(0,0,0,0.75); }
.app-wrapper.dark .cot-modal { background: #1e1e1e; }
.app-wrapper.dark .cot-header { background: #2a2008; border-bottom: 2px solid #c09d62; }
.app-wrapper.dark .cot-header h3 { color: #c09d62; }
.app-wrapper.dark .cot-modal .modal-close-x { color: #c09d62 !important; }
.app-wrapper.dark .cot-body { background: #1e1e1e; }
.app-wrapper.dark .cot-empty { color: #6b7280; }
.app-wrapper.dark .cot-table th {
  background: #252525;
  color: #c09d62;
  border-bottom-color: #3a3a3a;
}
.app-wrapper.dark .cot-table td {
  color: #d1d5db;
  border-bottom-color: #2d2d2d;
}
.app-wrapper.dark .cot-table tr:hover td { background: #2a2a2a; }

/* ── Nota de Crédito ─────────────────────────────────────── */
/* ── Botón Aplicar NC en footer ── */
.btn-aplicar-nc {
  position: relative;
  background-color: #f5ede0 !important;
  border: 1.5px solid #c09d62 !important;
  color: #7a5c2e !important;
}
.btn-aplicar-nc:hover:not(:disabled) {
  background-color: #ecdcc4 !important;
  border-color: #a8844e !important;
  color: #5a3e18 !important;
}
.btn-aplicar-nc:disabled {
  background-color: #f0ece6 !important;
  border-color: #d9c9a8 !important;
  color: #b8a07a !important;
}

.dark .btn-aplicar-nc {
  background-color: #241e14 !important;
  border: 1.5px solid #c09d62 !important;
  color: #c09d62 !important;
}
.dark .btn-aplicar-nc:hover:not(:disabled) {
  background-color: #2e2616 !important;
  border-color: #d4b07a !important;
  color: #d4b07a !important;
}
.dark .btn-aplicar-nc:disabled {
  background-color: #1a1610 !important;
  border-color: #4a3d25 !important;
  color: #6b5535 !important;
}

/* ── NC badge en botón ── */
.nc-badge-btn {
  position: absolute; top: 4px; right: 6px;
  background: #28a745; color: #fff;
  border-radius: 50%; width: 14px; height: 14px;
  font-size: 9px; display: flex; align-items: center; justify-content: center;
}

/* ── Modal NC — fuerza light mode (VentasList usa token oscuro globalmente) ── */
.nc-modal-box {
  max-width: 460px;
  padding: 0;
  background: #ffffff !important;
  border: none !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.25) !important;
}

.nc-modal-inner {
  padding: 24px;
}

.nc-modal-title {
  margin: 0 0 18px;
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 24px 0;
}
.nc-modal-title i { color: #c09d62; }

/* Franja dorada top */
.nc-modal-box::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, #c09d62, #e8c97a, #c09d62);
}

.nc-loading { color: #888; font-size: 14px; padding: 24px 0; text-align: center; }

.nc-empty { text-align: center; padding: 24px 0; color: #aaa; font-size: 13px; display: flex; flex-direction: column; align-items: center; gap: 8px; }

.nc-filter-input {
  width: 100%;
  box-sizing: border-box;
  padding: 9px 14px 9px 36px;
  border: 1.5px solid #e8ecf0;
  border-radius: 10px;
  font-size: 13px;
  margin-bottom: 12px;
  background: #f7f8fa url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 16 16'%3E%3Cpath fill='%23aaa' d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.099zm-5.242 1.656a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z'/%3E%3C/svg%3E") no-repeat 12px center;
  color: #333;
  outline: none;
  transition: border-color .15s;
}
.nc-filter-input:focus { border-color: #c09d62; background-color: #fff; }

.nc-list { display: flex; flex-direction: column; gap: 6px; max-height: 300px; overflow-y: auto; padding: 0 24px; margin-bottom: 4px; }

.nc-list::-webkit-scrollbar { width: 4px; }
.nc-list::-webkit-scrollbar-track { background: transparent; }
.nc-list::-webkit-scrollbar-thumb { background: #e0d4c0; border-radius: 4px; }

.nc-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #fafafa;
  border: 1.5px solid #f0f0f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all .15s;
}
.nc-list-item:hover {
  border-color: #c09d62;
  background: #fffbf5;
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(192,157,98,.15);
}
.nc-list-left { flex: 1; display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.nc-list-num  { font-size: 13px; font-weight: 700; color: #1a1a2e; letter-spacing: .3px; }
.nc-list-motivo { font-size: 11px; color: #999; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.nc-list-right { display: flex; flex-direction: column; align-items: flex-end; gap: 3px; flex-shrink: 0; }
.nc-list-monto { font-size: 15px; font-weight: 800; color: #c09d62; }
.nc-list-fecha { font-size: 11px; color: #bbb; }
.nc-list-arrow { color: #ddd; font-size: 11px; flex-shrink: 0; transition: color .15s; }
.nc-list-item:hover .nc-list-arrow { color: #c09d62; }

/* ── Detalle NC ── */
.nc-result-card {
  background: #f7f8fa;
  border: 1.5px solid #eef0f3;
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.nc-result-row { display: flex; justify-content: space-between; align-items: center; font-size: 13px; }
.nc-label { color: #8a94a6; font-weight: 600; font-size: 12px; text-transform: uppercase; letter-spacing: .4px; }
.nc-val { font-weight: 600; color: #1a1a2e; }

/* Secciones con padding */
.nc-modal-box .nc-modal-title,
.nc-modal-box > div { padding-left: 24px; padding-right: 24px; }
.nc-modal-box .nc-list { padding-left: 24px; padding-right: 24px; }

.nc-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
}
.nc-btn-back {
  background: #ef4444;
  border: none;
  border-radius: 10px;
  padding: 9px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all .15s;
}
.nc-btn-back:hover { background: #dc2626; color: #fff; }
.nc-btn-apply {
  background: #198754;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 22px;
  cursor: pointer;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 4px 12px rgba(192,157,98,.35);
  transition: all .15s;
}
.nc-btn-apply:hover:not(:disabled) { background: #146c43; transform: translateY(-1px); }
.nc-btn-apply:disabled { opacity: .5; cursor: not-allowed; transform: none; box-shadow: none; }

.app-wrapper.dark .nc-btn-apply {
  background: #198754 !important;
  color: #fff !important;
  border: none !important;
  box-shadow: none !important;
}
.app-wrapper.dark .nc-btn-apply:hover:not(:disabled) {
  background: #146c43 !important;
  transform: translateY(-1px);
}
.app-wrapper.dark .nc-btn-apply:disabled {
  background: rgba(25,135,84, 0.3) !important;
  color: #aaa !important;
  border: none !important;
  box-shadow: none !important;
  opacity: 1 !important;
}
.nc-btn-cancel {
  display: block;
  width: calc(100% - 48px);
  margin: 0 24px 20px;
  background: none;
  border: 1.5px solid #e8ecf0;
  border-radius: 10px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #777;
  text-align: center;
  transition: all .15s;
}
.nc-btn-cancel:hover { border-color: #ccc; color: #444; }

/* filtro dentro del modal box padding */
.nc-modal-box .nc-filter-wrap { padding: 0 24px; }

/* ── Dark mode (si la app lo activa) ── */
.app-wrapper.dark .nc-modal-box { background: #1e1e1e !important; box-shadow: 0 20px 60px rgba(0,0,0,.5) !important; }
.app-wrapper.dark .nc-modal-title { color: #c09d62; }
.app-wrapper.dark .nc-modal-title i { color: #c09d62; }
.app-wrapper.dark .nc-filter-input { background: #2a2a2a; border-color: #3a3a3a; color: #e5e7eb; }
.app-wrapper.dark .nc-filter-input::placeholder { color: #6b7280; }
.app-wrapper.dark .nc-filter-input:focus { border-color: #c09d62; }
.app-wrapper.dark .nc-list-item { background: #252525; border-color: #3a3a3a; color: #d1d5db; }
.app-wrapper.dark .nc-list-item:hover { border-color: #c09d62; background: #2a2510; }
.app-wrapper.dark .nc-list-num { color: #e5e7eb; }
.app-wrapper.dark .nc-list-motivo { color: #6b7280; }
.app-wrapper.dark .nc-list-fecha { color: #6b7280; }
.app-wrapper.dark .nc-result-card { background: #252525; border-color: #3a3a3a; }
.app-wrapper.dark .nc-label { color: #9ca3af; }
.app-wrapper.dark .nc-val { color: #e5e7eb; }
.app-wrapper.dark .nc-modal-footer { border-color: #3a3a3a; background: #1e1e1e; }
.app-wrapper.dark .nc-btn-back {
  background: #ef4444 !important;
  border: none !important;
  color: #fff !important;
}
.app-wrapper.dark .nc-btn-back:hover { background: #dc2626 !important; color: #fff !important; }
.app-wrapper.dark .nc-btn-cancel { background: #2a2a2a; border-color: #3a3a3a; color: #9ca3af; }

/* NC seleccionada */
.nc-list-item-sel { border-color: #c09d62 !important; background: #fffbf0 !important; }
.app-wrapper.dark .nc-list-item-sel { background: #2d2710 !important; border-color: #c09d62 !important; }

/* Banner notificación anulación */
.notif-anulacion-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #7f1d1d;
  color: #fef2f2;
  border: 1px solid #b91c1c;
  border-radius: 10px;
  padding: 12px 16px;
  margin: 0 0 10px;
  animation: fadeInDown .3s ease;
}
@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-10px); }
  to   { opacity: 1; transform: translateY(0); }
}
.notif-anulacion-icon { font-size: 20px; color: #fca5a5; flex-shrink: 0; margin-top: 1px; }
.notif-anulacion-text { flex: 1; font-size: 14px; line-height: 1.4; }
.notif-anulacion-close {
  background: none; border: none; color: #fca5a5; cursor: pointer;
  font-size: 14px; padding: 2px; border-radius: 4px; flex-shrink: 0;
  transition: color .2s;
}
.notif-anulacion-close:hover { color: #fff; }

/* ═══════════════════════════════════════════════════════════
   RESPONSIVE MÓVIL (≤ 600px) — Cajero en celular
   Columnas visibles en tabla: Item · Producto · Cant · Precio · Total
═══════════════════════════════════════════════════════════ */



/* =================================================================
   TABLET 601-960px — Portrait angosta y landscape medio
   Mejora sobre el bloque @768px que tiene excesos de gap/margin
================================================================= */

/* ── Tablet ancha (769-960px): layout en fila como desktop pero ajustado ── */
@media screen and (min-width: 769px) and (max-width: 960px) {
  .header-container { gap: 8px; padding: 8px 12px; }
  .tipo-cliente, .informacion-1, .informacion-2 { margin-bottom: 0; }
  .informacion-1, .informacion-2 { font-size: 13px; }

  /* Layout fila: tabla | teclado */
  .column-container { flex-direction: row; height: calc(100vh - 130px); margin-bottom: 74px; }
  .right-section { width: 240px; min-width: 220px; border-left: 1px solid #ccc; border-top: none; padding: 10px; }
  .dark .right-section { border-left-color: #2b2b2b; }

  /* Teclado tactil comodo */
  .keypad { gap: 5px; }
  .keypad button { height: 44px; font-size: 18px; border-radius: 8px; }
  .campo { height: 42px; font-size: 18px; }
  .abrir-caja-button { padding: 12px; font-size: 15px; }

  /* Ocultar columna tipo-desc en tablet para ahorrar ancho */
  .col-tipo-desc { display: none !important; }
  .table thead th, .table tbody td { padding: 7px 6px; font-size: 13px; }

  /* Footer: 4 botones por fila */
  .footer-container { flex-wrap: wrap; gap: 5px; justify-content: flex-start; }
  .footer-container button { width: calc(25% - 4px); min-width: 72px; height: 52px; font-size: 10px; border-radius: 8px; }
}

/* ── Tablet angosta (601-768px): layout en columna pero sin el gap excesivo del @768px ── */
@media screen and (min-width: 601px) and (max-width: 768px) {
  /* Corregir el gap:20px del @768px antiguo */
  .header-container { gap: 6px !important; padding: 6px 10px; }
  .tipo-cliente, .informacion-1, .informacion-2 { margin-bottom: 2px !important; }

  /* Layout columna: tabla arriba, teclado abajo */
  .column-container { flex-direction: column; height: auto; margin-bottom: 74px; }
  .right-section { width: 100%; border-left: none; border-top: 1px solid #ccc; padding: 10px; }
  .dark .right-section { border-top-color: #2b2b2b; }

  /* Ocultar Codigo y tipo-desc, mostrar el resto */
  .col-codigo, .col-tipo-desc { display: none !important; }

  /* Teclado en grid 5 columnas para aprovechar el ancho */
  .keypad { gap: 5px; }
  .keypad button { height: 46px; font-size: 20px; border-radius: 8px; }
  .campo { height: 42px; font-size: 18px; }
  .abrir-caja-button { padding: 12px; font-size: 15px; }

  /* Tabla: altura media */
  .table tbody { max-height: 30vh; }

  /* Footer: 4 botones por fila */
  .footer-container { flex-wrap: wrap; gap: 5px; justify-content: flex-start; }
  .footer-container button { width: calc(25% - 4px); min-width: 76px; height: 54px; font-size: 11px; border-radius: 8px; }
}

/* keypad-cerrado-overlay oculto por defecto — ANTES de @media para que media queries puedan sobreescribirlo */
.keypad-cerrado-overlay { display: none; }

/* =================================================================
   RESPONSIVE MOVIL — Portrait le 600 px
   Columnas visibles: Item - Producto - Cant - Precio - Total
================================================================= */
@media screen and (max-width: 600px) {

  /* Pill usuario: solo avatar */
  .usr-info, .usr-caret { display: none; }
  .usr-pill-wrap { top: 6px; right: 8px; }
  .usr-avatar { width: 32px; height: 32px; font-size: 11px; border-radius: 7px; }
  .usr-pill { padding: 4px; }

  /* Header ultra-compacto */
  .header-container {
    flex-direction: column;
    gap: 3px;
    padding: 4px 8px;
    padding-top: 40px;
    max-width: 100%;
  }

  /* Ocultar etiqueta "Cliente:" para ahorrar espacio */
  .tipo-cliente > label { display: none; }

  /* Ocultar informacion-2 (Usuario/Fecha) en portrait */
  .informacion-2 { display: none !important; }

  /* informacion-1: Sucursal + estado en una sola fila */
  .informacion-1 {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    padding: 0;
    width: 100%;
    margin-bottom: 0 !important;
  }

  /* tipo-cliente ocupa todo el ancho */
  .tipo-cliente { width: 100%; padding: 0; margin-bottom: 0 !important; }

  /* input-button-container: input + boton en UNA fila horizontal */
  .input-button-container {
    flex-direction: row !important;
    align-items: center;
    gap: 6px;
    width: 100%;
  }

  /* inputs-container: tomar espacio disponible */
  .inputs-container {
    flex: 1;
    flex-direction: row !important;
    gap: 4px;
    width: auto !important;
    min-width: 0;
  }

  /* RTN: oculto */
  .rtn-input { display: none !important; }

  /* Cliente input */
  .cliente-input { flex: 1; width: auto !important; font-size: 13px; height: 34px; }

  /* Botones del header: ancho auto */
  .buttons-header {
    flex-direction: row !important;
    gap: 4px;
    width: auto !important;
    flex-shrink: 0;
  }

  /* Buscar: compacto */
  .search-button { width: auto !important; min-width: 60px; height: 34px; font-size: 12px; }

  /* Layout principal */
  .column-container {
    flex-direction: column;
    height: auto;
    min-height: 0;
    gap: 0;
    margin-bottom: 74px;
  }

  /* Tabla: 5 columnas (ocultar Codigo, Subtotal, Descuento, Tipo) */
  .col-codigo, .col-descuento, .col-tipo-desc { display: none !important; }
  .table thead tr > th:nth-child(6),
  .table tbody tr > td:nth-child(6) { display: none !important; }
  .table, .table thead, .table tbody tr { table-layout: auto; }
  .table thead th, .table tbody td { padding: 6px 4px; font-size: 12px; }
  /* Tabla mas pequena para dar espacio al teclado */
  .table tbody { height: auto; max-height: 20vh; min-height: 60px; }
  .table-container { overflow-y: visible; }
  .table-wrapper { height: auto; }

  /* Totales compactos en una fila */
  .total-container {
    padding: 5px 10px;
    gap: 4px;
    flex-wrap: nowrap !important;
    justify-content: space-between;
    align-items: center;
  }
  .subTotal { font-size: 22px; }

  /* Seccion teclado */
  .right-section {
    width: 100%;
    border-left: none;
    border-top: 2px solid #ccc;
    padding: 8px;
    gap: 5px;
    position: relative;
  }
  .dark .right-section { border-top-color: #2b2b2b; }

  /* Campo de entrada */
  .campo { height: 44px; font-size: 20px; margin-bottom: 4px; border-radius: 8px; }

  /* Teclado numerico: touch-friendly y que quepan todos los botones */
  .keypad { gap: 5px; }
  .keypad button { height: 48px !important; font-size: 20px !important; border-radius: 10px; }

  /* Boton Abrir/Cerrar caja */
  .abrir-caja-button { margin-top: 4px !important; padding: 11px; font-size: 15px; border-radius: 10px; }

  /* Footer: scroll horizontal tactil */
  .footer-container {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    gap: 4px;
    padding: 4px 6px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .footer-container::-webkit-scrollbar { display: none; }
  .footer-container button {
    width: 64px; min-width: 64px; height: 56px;
    font-size: 10px; flex-shrink: 0;
    border-radius: 8px; padding: 4px 3px; line-height: 1.3;
  }

  /* Overlay caja cerrada — display:flex !important para ganar al default display:none */
  .numeric-keypad { position: relative; }
  .keypad-cerrado-overlay {
    display: flex !important;
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.72);
    border-radius: 10px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 20;
    cursor: pointer;
    gap: 6px;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
  }
  .keypad-cerrado-msg {
    display: flex; flex-direction: column;
    align-items: center; gap: 6px;
    color: #fff;
  }
  .keypad-cerrado-msg i   { font-size: 32px; color: #c09d62; }
  .keypad-cerrado-msg p   { font-size: 16px; font-weight: 700; margin: 0; }
  .keypad-cerrado-msg span {
    font-size: 13px; color: rgba(255,255,255,.7);
    background: rgba(192,157,98,.25); border: 1px solid rgba(192,157,98,.4);
    padding: 4px 14px; border-radius: 20px;
  }

  /* Notificacion venta anulada */
  .notif-anulacion-banner { font-size: 12px; padding: 8px 10px; }
}

/* =================================================================
   LANDSCAPE MOVIL — Telefono horizontal (altura le 500px)
   Layout: tabla izquierda | teclado derecha
================================================================= */
@media screen and (max-height: 500px) and (orientation: landscape) and (max-width: 960px) {

  /* Pill usuario */
  .usr-info, .usr-caret { display: none; }
  .usr-pill-wrap { top: 4px; right: 6px; }
  .usr-avatar { width: 28px; height: 28px; font-size: 10px; }
  .usr-pill { padding: 3px; }

  /* Header ultra-compacto: TODO en una sola fila */
  .header-container {
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 4px 8px;
    padding-top: 4px;
    gap: 6px;
    align-items: center;
    max-width: 100%;
  }

  /* Ocultar "Cliente:" label en landscape */
  .tipo-cliente > label { display: none; }

  /* Ocultar informacion-2 en landscape */
  .informacion-2 { display: none !important; }

  /* tipo-cliente: compacto */
  .tipo-cliente { flex: 0 1 55%; padding: 0; margin-bottom: 0 !important; min-width: 0; }

  /* input-button-container: fila */
  .input-button-container {
    flex-direction: row !important;
    align-items: center;
    gap: 4px;
    width: 100%;
  }

  /* Inputs: tomar espacio */
  .inputs-container {
    flex: 1;
    flex-direction: row !important;
    width: auto !important;
    min-width: 0;
  }

  .rtn-input { display: none !important; }
  .cliente-input { flex: 1; width: auto !important; font-size: 12px; height: 28px; }

  .buttons-header { flex-direction: row !important; gap: 3px; width: auto !important; flex-shrink: 0; }
  .search-button { width: auto !important; min-width: 52px; height: 28px; font-size: 11px; }

  /* informacion-1: texto compacto */
  .informacion-1 {
    flex: 1;
    max-width: 45%;
    padding: 0;
    font-size: 10px;
    align-items: flex-start;
    margin-bottom: 0 !important;
    flex-direction: column;
    justify-content: center;
  }

  /* Layout principal: tabla | teclado lado a lado */
  .column-container {
    flex-direction: row !important;
    height: calc(100vh - 92px);
    margin-bottom: 52px;
    gap: 6px;
    flex-wrap: nowrap;
  }
  .table-container { flex: 1 1 auto; overflow-y: auto; min-width: 0; }
  .table-wrapper { height: 100%; }
  .table tbody { max-height: calc(100vh - 150px); height: auto; }

  /* Columnas ocultas en landscape */
  .col-codigo, .col-descuento, .col-tipo-desc { display: none !important; }
  .table thead tr > th:nth-child(6),
  .table tbody tr > td:nth-child(6) { display: none !important; }
  .table, .table thead, .table tbody tr { table-layout: auto; }
  .table thead th, .table tbody td { padding: 5px 4px; font-size: 11px; }

  /* Seccion teclado: columna derecha fija */
  .right-section {
    width: 172px !important;
    min-width: 172px !important;
    border-left: 1px solid #ccc !important;
    border-top: none !important;
    padding: 5px !important;
    gap: 3px;
    position: relative;
  }
  .dark .right-section { border-left-color: #2b2b2b !important; }

  /* Campo */
  .campo { height: 30px; font-size: 14px; margin-bottom: 3px; border-radius: 6px; }

  /* Teclado compacto en landscape */
  .keypad { gap: 3px; }
  .keypad button { height: 32px !important; font-size: 13px !important; border-radius: 5px; }

  /* Boton caja */
  .abrir-caja-button { margin-top: 3px !important; padding: 5px; font-size: 12px; border-radius: 7px; }

  /* Totales */
  .total-container { padding: 3px 8px; gap: 4px; flex-wrap: nowrap !important; }
  .cantidad-input input { width: 52px; }
  .subTotal { font-size: 17px; }

  /* Footer: scroll horizontal */
  .footer-container {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    gap: 3px; padding: 3px 6px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .footer-container::-webkit-scrollbar { display: none; }
  .footer-container button {
    width: 50px; min-width: 50px; height: 40px;
    font-size: 9px; flex-shrink: 0;
    border-radius: 6px; padding: 3px 2px; line-height: 1.2;
  }

  /* Overlay caja cerrada en landscape */
  .numeric-keypad { position: relative; }
  .keypad-cerrado-overlay { display: flex !important; }
  .keypad-cerrado-msg i   { font-size: 22px; }
  .keypad-cerrado-msg p   { font-size: 12px; }
  .keypad-cerrado-msg span { font-size: 10px; padding: 2px 8px; }
}

/* Boton volver al panel (Admin en caja) */
.admin-caja-back {
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 999;
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 4px 10px;
  background: rgba(20, 20, 20, 0.75);
  border: 1px solid rgba(192, 157, 98, 0.3);
  border-radius: 6px;
  color: #c09d62;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  backdrop-filter: blur(4px);
  transition: background .18s, border-color .18s;
  white-space: nowrap;
}
.admin-caja-back i { font-size: 16px; }
.admin-caja-back:hover {
  background: rgba(192, 157, 98, 0.15);
  border-color: rgba(192, 157, 98, 0.6);
}
</style>
